import { PlayActivity } from '../types';

export const PLAY_ACTIVITIES: PlayActivity[] = [
  {
    id: 'bubbles',
    label: 'Juego de burbujas',
    icon: '🫧',
    description: 'Sopla burbujas para respirar profundo',
    category: 'breathing'
  },
  {
    id: 'drawing',
    label: 'Dibuja lo que sientes',
    icon: '🎨',
    description: 'Expresa tus emociones dibujando',
    category: 'creative'
  },
  {
    id: 'superpowers',
    label: 'Mis superpoderes',
    icon: '✨',
    description: 'Descubre tus poderes especiales',
    category: 'affirmations'
  },
  {
    id: 'story',
    label: 'Crea tu historia',
    icon: '📖',
    description: 'Inventa una historia divertida',
    category: 'creative'
  }
];

export const CHAT_ACTIVITIES = [
  { id: 'drawing', label: 'Dibuja lo que sientes', icon: '🎨', description: 'Expresa tus emociones dibujando' }
];

import { Gender } from '../hooks/useGender';

export const EMOTION_REASONS_MASCULINE: Record<string, string[]> = {
  happy: [
    'Aprobé un examen',
    'Hice un amigo nuevo',
    'Jugué con amigos',
    'Me regalaron algo',
    'Comí algo rico',
    'Me divertí mucho',
    'Otro'
  ],
  sad: [
    'Extraño a alguien',
    'Me siento solo',
    'Algo malo pasó',
    'Me regañaron',
    'No puedo jugar',
    'Me duele algo',
    'Otro'
  ],
  anxious: [
    'Tengo un examen',
    'Algo me da miedo',
    'No sé qué hacer',
    'Me preocupa algo',
    'Tengo mucha tarea',
    'Hay cambios en mi vida',
    'Otro'
  ],
  angry: [
    'Me regañaron injustamente',
    'Alguien me molestó',
    'No puedo hacer lo que quiero',
    'Algo salió mal',
    'Me frustré',
    'Alguien rompió algo mío',
    'Otro'
  ],
  tired: [
    'Dormí poco',
    'Tengo mucha tarea',
    'Jugué mucho',
    'Estoy enfermo',
    'Hice ejercicio',
    'Fui a una fiesta',
    'Otro'
  ],
  calm: [
    'Estoy tranquilo',
    'Todo está bien',
    'Descansé',
    'Estoy con mi familia',
    'Estoy en un lugar bonito',
    'Hice algo que me gusta',
    'Otro'
  ]
};

export const EMOTION_REASONS_FEMININE: Record<string, string[]> = {
  happy: [
    'Aprobé un examen',
    'Hice una amiga nueva',
    'Jugué con amigas',
    'Me regalaron algo',
    'Comí algo rico',
    'Me divertí mucho',
    'Otro'
  ],
  sad: [
    'Extraño a alguien',
    'Me siento sola',
    'Algo malo pasó',
    'Me regañaron',
    'No puedo jugar',
    'Me duele algo',
    'Otro'
  ],
  anxious: [
    'Tengo un examen',
    'Algo me da miedo',
    'No sé qué hacer',
    'Me preocupa algo',
    'Tengo mucha tarea',
    'Hay cambios en mi vida',
    'Otro'
  ],
  angry: [
    'Me regañaron injustamente',
    'Alguien me molestó',
    'No puedo hacer lo que quiero',
    'Algo salió mal',
    'Me frustré',
    'Alguien rompió algo mío',
    'Otro'
  ],
  tired: [
    'Dormí poco',
    'Tengo mucha tarea',
    'Jugué mucho',
    'Estoy enferma',
    'Hice ejercicio',
    'Fui a una fiesta',
    'Otro'
  ],
  calm: [
    'Estoy tranquila',
    'Todo está bien',
    'Descansé',
    'Estoy con mi familia',
    'Estoy en un lugar bonito',
    'Hice algo que me gusta',
    'Otro'
  ]
};

export const getEmotionReasons = (gender: Gender | null) => {
  if (gender === 'female') return EMOTION_REASONS_FEMININE;
  return EMOTION_REASONS_MASCULINE;
};

// Mantenemos compatibilidad con imports anteriores
export const EMOTION_REASONS = EMOTION_REASONS_MASCULINE;

export const GRATITUDE_SUGGESTIONS = {
  happy: [
    'Comí algo rico',
    'Me abrazaron',
    'Vi un animal',
    'Jugué',
    'Me reí mucho'
  ],
  person: [
    'Mamá/Papá',
    'Mi mejor amigo',
    'Mi maestra',
    'Mi mascota',
    'Mi abuelo/a'
  ],
  fun: [
    'Corrí',
    'Dibujé',
    'Canté',
    'Bailé',
    'Jugué videojuegos'
  ]
};

export const DAILY_GOALS = {
  kind: {
    label: 'Ser amable',
    icon: '💚',
    options: ['Decir gracias', 'Ayudar a alguien', 'Dar un abrazo', 'Compartir mis cosas']
  },
  help: {
    label: 'Ayudar en casa',
    icon: '🏠',
    options: ['Limpiar mi cuarto', 'Poner la mesa', 'Sacar la basura', 'Hacer mi cama']
  },
  outside: {
    label: 'Jugar afuera',
    icon: '⚽',
    options: ['Caminar 10 minutos', 'Jugar fútbol', 'Montar bicicleta', 'Correr']
  },
  vegetables: {
    label: 'Comer verduras',
    icon: '🥦',
    options: ['Comer una ensalada', 'Comer zanahorias', 'Comer brócoli', 'Tomar jugo verde']
  },
  read: {
    label: 'Leer un libro',
    icon: '📚',
    options: ['Leer 10 páginas', 'Leer un cuento', 'Leer antes de dormir', 'Leer con mamá/papá']
  },
  share: {
    label: 'Compartir',
    icon: '🤝',
    options: ['Compartir mi juguete', 'Compartir mi comida', 'Jugar con otros', 'Invitar a alguien']
  }
};

export const AFFIRMATIONS = [
  'Soy valiente y enfrento mis miedos',
  'Puedo hacer cosas increÃ­bles',
  'Soy especial y Ãºnico',
  'Tengo amigos que me quieren',
  'Soy creativo e imaginativo',
  'Me caigo bien tal como soy',
  'Puedo aprender cosas nuevas',
  'Soy amable con los demÃ¡s',
  'Mis ideas son importantes',
  'Soy inteligente y resuelvo problemas',
  'Puedo superar cualquier desafÃ­o',
  'Soy un buen amigo',
  'Mis sentimientos son importantes',
  'Puedo hacer el bien en el mundo',
  'Soy fuerte por dentro',
  'Me esfuerzo y eso es valioso',
  'Soy responsable con mis acciones',
  'Puedo ayudar a otros cuando lo necesitan',
  'Soy honesto y digo la verdad',
  'Tengo talentos especiales',
  'Puedo cambiar las cosas positivamente',
  'Soy respetuoso con todos',
  'Mis sueÃ±os pueden hacerse realidad',
  'Soy paciente cuando es necesario',
  'Puedo perdonar y seguir adelante',
  'Soy generoso y comparto con otros',
  'Tengo una actitud positiva',
  'Puedo expresar mis sentimientos',
  'Soy curioso y aprendo siempre',
  'Mis errores me ayudan a crecer',
  'Soy valioso y merezco amor',
  'Puedo hacer grandes cosas',
  'Soy feliz cuando soy yo mismo',
  'Tengo el poder de elegir bien',
  'Soy especial de muchas maneras',
  'Puedo hacer del mundo un lugar mejor',
  'Mi voz es importante',
  'Soy capaz de lograr mis metas',
  'Tengo el coraje de ser yo mismo',
  'Puedo encontrar soluciones creativas',
  'Soy amado y apreciado',
  'Mis acciones tienen impacto positivo',
  'Puedo adaptarme a los cambios',
  'Soy digno de confianza',
  'Tengo el poder de la felicidad',
  'Puedo inspirar a otros',
  'Soy fuerte cuando enfrento dificultades',
  'Mis ideas pueden cambiar el mundo',
  'Puedo hacer la diferencia',
  'Soy autÃ©ntico y verdadero',
  'Tengo el poder de la bondad',
  'Puedo crear mi propio camino',
  'Soy resiliente y me levanto',
  'Mis cualidades me hacen especial',
  'Puedo amar y ser amado',
  'Tengo el poder de la esperanza',
  'Puedo superar obstÃ¡culos',
  'Soy digno de respeto y amor',
  'Mis palabras tienen poder',
  'Puedo hacer que cada dÃ­a cuente',
  'Soy una fuente de luz para otros',
  'Tengo el poder de la autenticidad',
  'Puedo inspirar cambios',
  'Soy capaz de grandes logros',
  'Tengo el poder de la compasiÃ³n',
  'Puedo construir relaciones fuertes',
  'Soy digno de Ã©xito y felicidad',
  'Mis acciones hablan mÃ¡s fuerte que las palabras',
  'Puedo crear momentos especiales',
  'Soy capaz de amar incondicionalmente',
  'Tengo el poder de la perseverancia',
  'Puedo encontrar paz interior',
  'Soy capaz de amar profundamente',
  'Mis valores me guÃ­an bien',
  'Puedo crear mi propia felicidad',
  'Soy digno de amor y respeto',
  'Tengo el poder de la autenticidad',
  'Puedo inspirar cambios positivos',
  'Soy fuerte en cuerpo y mente',
  'Mis pensamientos crean mi realidad',
  'Puedo hacer que el mundo sonrÃ­a',
  'Soy capaz de amar sin miedo',
  'Tengo el poder de la bondad pura',
  'Puedo encontrar fuerza en la adversidad',
  'Soy digno de todas las bendiciones',
  'Mis acciones reflejan mi corazÃ³n',
  'Puedo hacer que cada momento cuente',
  'Soy una persona Ãºnica y valiosa',
  'Tengo el poder de la esperanza eterna',
  'Puedo superar cualquier lÃ­mite',
  'Soy capaz de amar sin medida',
  'Mis sueÃ±os son mi brÃºjula',
  'Puedo encontrar alegrÃ­a en cada dÃ­a',
  'Soy digno de todo lo bueno',
  'Tengo el poder de la determinaciÃ³n',
  'Puedo crear mi propio destino',
  'Soy fuerte cuando mÃ¡s lo necesito',
  'Mis palabras pueden sanar',
  'Puedo hacer que otros se sientan especiales',
  'Soy capaz de amar sin reservas',
  'Tengo el poder de la fe en mÃ­ mismo',
  'Puedo encontrar fuerza en la debilidad',
  'Soy digno de ser amado plenamente',
  'Mis acciones tienen propÃ³sito',
  'Puedo hacer que la vida sea hermosa',
  'Soy una persona de gran valor',
  'Tengo el poder de la pasiÃ³n',
  'Puedo encontrar significado en todo',
  'Soy capaz de amar con todo mi ser',
  'Mis elecciones crean mi futuro',
  'Puedo hacer que cada momento cuente',
  'Soy digno de amor incondicional',
  'Tengo el poder de la creatividad',
  'Puedo superar cualquier reto',
  'Soy fuerte cuando me enfrento a miedos',
  'Mis sueÃ±os merecen ser realidad',
  'Puedo hacer que el mundo sea mejor',
  'Soy capaz de amar sin condiciones',
  'Tengo el poder de la perseverancia',
  'Puedo encontrar felicidad en mÃ­',
  'Soy digno de respeto y admiraciÃ³n',
  'Mis acciones tienen significado',
  'Puedo crear mi felicidad',
  'Soy una persona maravillosa',
  'Tengo el poder de la esperanza',
  'Puedo hacer la diferencia',
  'Soy capaz de amar y ser amado',
  'Mis valores me hacen fuerte',
  'Puedo encontrar fuerza cuando la necesito',
  'Soy digno de Ã©xito y prosperidad',
  'Tengo el poder de la gratitud',
  'Puedo construir un futuro brillante',
  'Soy capaz de grandes cosas',
  'Mis sueÃ±os merecen ser perseguidos',
  'Puedo encontrar belleza en la vida',
  'Soy digno de amor y felicidad',
  'Tengo el poder de la compasiÃ³n',
  'Puedo hacer que otros sonrÃ­an',
  'Soy valioso por ser quien soy',
  'Mis acciones tienen impacto',
  'Puedo crear momentos inolvidables',
  'Soy capaz de amar',
  'Tengo el poder de la resiliencia',
  'Puedo encontrar paz',
  'Soy digno de todo',
  'Mis palabras tienen poder',
  'Puedo hacer que cada dÃ­a cuente',
  'Soy una fuente de inspiraciÃ³n',
  'Tengo el poder de la autenticidad',
  'Puedo inspirar cambios',
  'Soy fuerte',
  'Mis pensamientos crean mi realidad',
  'Puedo hacer que la vida sea hermosa',
  'Soy capaz de amar profundamente',
  'Tengo el poder de la bondad',
  'Puedo encontrar fuerza',
  'Soy digno de respeto',
  'Mis acciones reflejan mi corazÃ³n',
  'Puedo hacer que otros se sientan especiales',
  'Soy una persona Ãºnica',
  'Tengo el poder de la esperanza',
  'Puedo superar',
  'Soy capaz de amar',
  'Mis sueÃ±os merecen ser perseguidos',
  'Puedo encontrar alegrÃ­a',
  'Soy digno de amor',
  'Tengo el poder de la determinaciÃ³n',
  'Puedo crear mi camino',
  'Soy fuerte',
  'Mis palabras pueden sanar',
  'Puedo hacer que otros se sientan bien',
  'Soy capaz de amar sin miedo',
  'Tengo el poder de la fe',
  'Puedo encontrar fuerza',
  'Soy digno de ser amado',
  'Mis acciones tienen propÃ³sito',
  'Puedo hacer que la vida sea especial',
  'Soy una persona de valor',
  'Tengo el poder de la pasiÃ³n',
  'Puedo encontrar significado',
  'Soy capaz de amar',
  'Mis elecciones crean mi futuro',
  'Puedo hacer que cada momento sea especial',
  'Soy digno de amor',
  'Tengo el poder de la creatividad',
  'Puedo superar',
  'Soy fuerte',
  'Mis sueÃ±os merecen ser realidad',
  'Puedo hacer que el mundo sea mejor',
  'Soy capaz de amar',
  'Tengo el poder de la perseverancia',
  'Puedo encontrar felicidad',
  'Soy digno de respeto',
  'Mis acciones tienen significado',
  'Puedo crear mi felicidad',
  'Soy una persona maravillosa',
  'Tengo el poder de la esperanza',
  'Puedo hacer la diferencia',
  'Soy capaz de amar y ser amado',
  'Mis valores me guÃ­an',
  'Puedo encontrar fuerza',
  'Soy digno de Ã©xito',
  'Tengo el poder de la gratitud',
  'Puedo construir mi futuro',
  'Soy capaz',
  'Mis sueÃ±os merecen ser cumplidos',
  'Puedo encontrar belleza',
  'Soy digno de todo lo bueno',
  'Tengo el poder de la determinaciÃ³n',
  'Puedo crear mi destino',
  'Soy fuerte',
  'Mis palabras pueden inspirar',
  'Puedo hacer que otros se sientan valiosos',
  'Soy capaz de amar',
  'Tengo el poder de la fe',
  'Puedo encontrar fuerza',
  'Soy digno de ser amado',
  'Mis acciones tienen propÃ³sito',
  'Puedo hacer que la vida valga la pena',
  'Soy una persona especial',
  'Tengo el poder de la pasiÃ³n',
  'Puedo encontrar significado',
  'Soy capaz de amar',
  'Mis elecciones definen mi camino',
  'Puedo hacer que cada momento sea especial',
  'Soy digno de amor',
  'Tengo el poder de la creatividad',
  'Puedo superar',
  'Soy fuerte',
  'Mis sueÃ±os merecen ser realidad',
  'Puedo hacer que el mundo sea mejor',
  'Soy capaz de amar',
  'Tengo el poder de la perseverancia',
  'Puedo encontrar felicidad',
  'Soy digno de respeto',
  'Mis acciones tienen significado',
  'Puedo crear mi destino',
  'Soy una persona maravillosa',
  'Tengo el poder de la esperanza',
  'Puedo hacer la diferencia',
  'Soy capaz de amar y ser amado',
  'Mis valores me hacen fuerte',
  'Puedo encontrar fuerza',
  'Soy digno de Ã©xito',
  'Tengo el poder de la gratitud',
  'Puedo construir mi futuro',
  'Soy capaz de grandes cosas',
  'Mis sueÃ±os merecen ser perseguidos',
  'Puedo encontrar belleza',
  'Soy digno de amor',
  'Tengo el poder de la compasiÃ³n',
  'Puedo hacer que otros sonrÃ­an',
  'Soy valioso',
  'Mis acciones tienen impacto',
  'Puedo crear momentos',
  'Soy capaz de amar',
  'Tengo el poder de la resiliencia',
  'Puedo encontrar paz',
  'Soy digno de todo',
  'Mis palabras tienen poder',
  'Puedo hacer que cada dÃ­a cuente',
  'Soy una fuente de luz',
  'Tengo el poder de la autenticidad',
  'Puedo inspirar cambios',
  'Soy fuerte',
  'Mis pensamientos crean mi realidad',
  'Puedo hacer que la vida sea hermosa',
  'Soy capaz de amar profundamente',
  'Tengo el poder de la bondad',
  'Puedo encontrar fuerza',
  'Soy digno de respeto',
  'Mis acciones reflejan mi corazÃ³n',
  'Puedo hacer que otros se sientan especiales',
  'Soy una persona Ãºnica',
  'Tengo el poder de la esperanza',
  'Puedo superar',
  'Soy capaz de amar',
  'Mis sueÃ±os merecen ser perseguidos',
  'Puedo encontrar alegrÃ­a',
  'Soy digno de amor',
  'Tengo el poder de la determinaciÃ³n',
  'Puedo crear mi camino',
  'Soy fuerte',
  'Mis palabras pueden sanar',
  'Puedo hacer que otros se sientan bien',
  'Soy capaz de amar sin miedo',
  'Tengo el poder de la fe',
  'Puedo encontrar fuerza',
  'Soy digno de ser amado',
  'Mis acciones tienen propÃ³sito',
  'Puedo hacer que la vida sea especial',
  'Soy una persona de valor',
  'Tengo el poder de la pasiÃ³n',
  'Puedo encontrar significado',
  'Soy capaz de amar',
  'Mis elecciones crean mi futuro',
  'Puedo hacer que cada momento cuente',
  'Soy digno de amor incondicional',
  'Tengo el poder de la creatividad',
  'Puedo superar',
  'Soy fuerte',
  'Mis sueÃ±os merecen ser realidad',
  'Puedo hacer que el mundo sea mejor',
  'Soy capaz de amar',
  'Tengo el poder de la perseverancia',
  'Puedo encontrar felicidad',
  'Soy digno de respeto',
  'Mis acciones tienen significado',
  'Puedo crear mi felicidad',
  'Soy una persona maravillosa',
  'Tengo el poder de la esperanza',
  'Puedo hacer la diferencia',
  'Soy capaz de amar y ser amado',
  'Mis valores me guÃ­an',
  'Puedo encontrar fuerza',
  'Soy digno de Ã©xito',
  'Tengo el poder de la gratitud',
  'Puedo construir mi futuro',
  'Soy capaz',
  'Mis sueÃ±os merecen ser cumplidos',
  'Puedo encontrar belleza',
  'Soy digno de todo lo bueno',
  'Tengo el poder de la determinaciÃ³n',
  'Puedo crear mi destino',
  'Soy fuerte',
  'Mis palabras pueden inspirar',
  'Puedo hacer que otros se sientan valiosos',
  'Soy capaz de amar',
  'Tengo el poder de la fe',
  'Puedo encontrar fuerza',
  'Soy digno de ser amado',
  'Mis acciones tienen propÃ³sito',
  'Puedo hacer que la vida valga la pena',
  'Soy una persona especial',
  'Tengo el poder de la pasiÃ³n',
  'Puedo encontrar significado',
  'Soy capaz de amar',
  'Mis elecciones definen mi camino',
  'Puedo hacer que cada momento sea especial',
  'Soy digno de amor',
  'Tengo el poder de la creatividad',
  'Puedo superar',
  'Soy fuerte',
  'Mis sueÃ±os merecen ser realidad',
  'Puedo hacer que el mundo sea mejor',
  'Soy capaz de amar',
  'Tengo el poder de la perseverancia',
  'Puedo encontrar felicidad',
  'Soy digno de respeto',
  'Mis acciones tienen significado',
  'Puedo crear mi destino',
  'Soy una persona maravillosa',
  'Tengo el poder de la esperanza',
  'Puedo hacer la diferencia',
  'Soy capaz de amar y ser amado',
  'Mis valores me hacen fuerte',
  'Puedo encontrar fuerza',
  'Soy digno de Ã©xito',
  'Tengo el poder de la gratitud',
  'Puedo construir mi futuro',
  'Soy capaz de grandes cosas',
  'Mis sueÃ±os merecen ser perseguidos',
  'Puedo encontrar belleza',
  'Soy digno de amor',
  'Tengo el poder de la compasiÃ³n',
  'Puedo hacer que otros sonrÃ­an',
  'Soy valioso',
  'Mis acciones tienen impacto',
  'Puedo crear momentos',
  'Soy capaz de amar',
  'Tengo el poder de la resiliencia',
  'Puedo encontrar paz',
  'Soy digno de todo',
  'Mis palabras tienen poder',
  'Puedo hacer que cada dÃ­a cuente',
  'Soy una fuente de luz',
  'Tengo el poder de la autenticidad',
  'Puedo inspirar cambios',
  'Soy fuerte',
  'Mis pensamientos crean mi realidad',
  'Puedo hacer que la vida sea hermosa',
  'Soy capaz de amar profundamente',
  'Tengo el poder de la bondad',
  'Puedo encontrar fuerza',
  'Soy digno de respeto',
  'Mis acciones reflejan mi corazÃ³n',
  'Puedo hacer que otros se sientan especiales',
  'Soy una persona Ãºnica',
  'Tengo el poder de la esperanza',
  'Puedo superar',
  'Soy capaz de amar',
  'Mis sueÃ±os merecen ser perseguidos',
  'Puedo encontrar alegrÃ­a',
  'Soy digno de amor',
  'Tengo el poder de la determinaciÃ³n',
  'Puedo crear mi camino',
  'Soy fuerte',
  'Mis palabras pueden sanar',
  'Puedo hacer que otros se sientan bien',
  'Soy capaz de amar sin miedo',
  'Tengo el poder de la fe',
  'Puedo encontrar fuerza',
  'Soy digno de ser amado',
  'Mis acciones tienen propÃ³sito',
  'Puedo hacer que la vida sea especial',
  'Soy una persona de valor',
  'Tengo el poder de la pasiÃ³n',
  'Puedo encontrar significado',
  'Soy capaz de amar',
  'Mis elecciones crean mi futuro',
  'Puedo hacer que cada momento cuente',
  'Soy digno de amor incondicional',
  'Tengo el poder de la creatividad',
  'Puedo superar',
  'Soy fuerte',
  'Mis sueÃ±os merecen ser realidad',
  'Puedo hacer que el mundo sea mejor',
  'Soy capaz de amar',
  'Tengo el poder de la perseverancia',
  'Puedo encontrar felicidad',
  'Soy digno de respeto',
  'Mis acciones tienen significado',
  'Puedo crear mi felicidad',
  'Soy una persona maravillosa',
  'Tengo el poder de la esperanza',
  'Puedo hacer la diferencia',
  'Soy capaz de amar y ser amado',
  'Mis valores me guÃ­an',
  'Puedo encontrar fuerza',
  'Soy digno de Ã©xito',
  'Tengo el poder de la gratitud',
  'Puedo construir mi futuro',
  'Soy capaz',
  'Mis sueÃ±os merecen ser cumplidos',
  'Puedo encontrar belleza',
  'Soy digno de todo lo bueno',
  'Tengo el poder de la determinaciÃ³n',
  'Puedo crear mi destino',
  'Soy fuerte',
  'Mis palabras pueden inspirar',
  'Puedo hacer que otros se sientan valiosos',
  'Soy capaz de amar',
  'Tengo el poder de la fe',
  'Puedo encontrar fuerza',
  'Soy digno de ser amado',
  'Mis acciones tienen propÃ³sito',
  'Puedo hacer que la vida valga la pena',
  'Soy una persona especial',
  'Tengo el poder de la pasiÃ³n',
  'Puedo encontrar significado',
  'Soy capaz de amar',
  'Mis elecciones definen mi camino',
  'Puedo hacer que cada momento sea especial',
  'Soy digno de amor',
  'Tengo el poder de la creatividad',
  'Puedo superar',
  'Soy fuerte',
  'Mis sueÃ±os merecen ser realidad',
  'Puedo hacer que el mundo sea mejor',
  'Soy capaz de amar',
  'Tengo el poder de la perseverancia',
  'Puedo encontrar felicidad',
  'Soy digno de respeto',
  'Mis acciones tienen significado',
  'Puedo crear mi destino',
  'Soy una persona maravillosa',
  'Tengo el poder de la esperanza',
  'Puedo hacer la diferencia',
  'Soy capaz de amar y ser amado',
  'Mis valores me hacen fuerte',
  'Puedo encontrar fuerza',
  'Soy digno de Ã©xito',
  'Tengo el poder de la gratitud',
  'Puedo construir mi futuro',
  'Soy capaz de grandes cosas',
  'Mis sueÃ±os merecen ser perseguidos',
  'Puedo encontrar belleza',
  'Soy digno de amor',
  'Tengo el poder de la compasiÃ³n',
  'Puedo hacer que otros sonrÃ­an',
  'Soy valioso',
  'Mis acciones tienen impacto',
  'Puedo crear momentos',
  'Soy capaz de amar',
  'Tengo el poder de la resiliencia',
  'Puedo encontrar paz',
  'Soy digno de todo',
  'Mis palabras tienen poder',
  'Puedo hacer que cada dÃ­a cuente',
  'Soy una fuente de luz',
  'Tengo el poder de la autenticidad',
  'Puedo inspirar cambios',
  'Soy fuerte',
  'Mis pensamientos crean mi realidad',
  'Puedo hacer que la vida sea hermosa',
  'Soy capaz de amar profundamente',
  'Tengo el poder de la bondad',
  'Puedo encontrar fuerza',
  'Soy digno de respeto',
  'Mis acciones reflejan mi corazÃ³n',
  'Puedo hacer que otros se sientan especiales',
  'Soy una persona Ãºnica',
  'Tengo el poder de la esperanza',
  'Puedo superar',
  'Soy capaz de amar',
  'Mis sueÃ±os merecen ser perseguidos',
  'Puedo encontrar alegrÃ­a',
  'Soy digno de amor',
  'Tengo el poder de la determinaciÃ³n',
  'Puedo crear mi camino',
  'Soy fuerte',
  'Mis palabras pueden sanar',
  'Puedo hacer que otros se sientan bien',
  'Soy capaz de amar sin miedo',
  'Tengo el poder de la fe',
  'Puedo encontrar fuerza',
  'Soy digno de ser amado',
  'Mis acciones tienen propÃ³sito',
  'Puedo hacer que la vida sea especial',
  'Soy una persona de valor',
  'Tengo el poder de la pasiÃ³n',
  'Puedo encontrar significado',
  'Soy capaz de amar',
  'Mis elecciones crean mi futuro',
  'Puedo hacer que cada momento cuente',
  'Soy digno de amor incondicional',
  'Tengo el poder de la creatividad',
  'Puedo superar',
  'Soy fuerte',
  'Mis sueÃ±os merecen ser realidad',
  'Puedo hacer que el mundo sea mejor',
  'Soy capaz de amar',
  'Tengo el poder de la perseverancia',
  'Puedo encontrar felicidad',
  'Soy digno de respeto',
  'Mis acciones tienen significado',
  'Puedo crear mi felicidad',
  'Soy una persona maravillosa',
  'Tengo el poder de la esperanza',
  'Puedo hacer la diferencia',
  'Soy capaz de amar y ser amado',
  'Mis valores me guÃ­an',
  'Puedo encontrar fuerza',
  'Soy digno de Ã©xito',
  'Tengo el poder de la gratitud',
  'Puedo construir mi futuro',
  'Soy capaz',
  'Mis sueÃ±os merecen ser cumplidos',
  'Puedo encontrar belleza',
  'Soy digno de todo lo bueno',
  'Tengo el poder de la determinaciÃ³n',
  'Puedo crear mi destino',
  'Soy fuerte',
  'Mis palabras pueden inspirar',
  'Puedo hacer que otros se sientan valiosos',
  'Soy capaz de amar',
  'Tengo el poder de la fe',
  'Puedo encontrar fuerza',
  'Soy digno de ser amado',
  'Mis acciones tienen propÃ³sito',
  'Puedo hacer que la vida valga la pena',
  'Soy una persona especial',
  'Tengo el poder de la pasiÃ³n',
  'Puedo encontrar significado',
  'Soy capaz de amar',
  'Mis elecciones definen mi camino',
  'Puedo hacer que cada momento sea especial',
  'Soy digno de amor',
  'Tengo el poder de la creatividad',
  'Puedo superar',
  'Soy fuerte',
  'Mis sueÃ±os merecen ser realidad',
  'Puedo hacer que el mundo sea mejor',
  'Soy capaz de amar',
  'Tengo el poder de la perseverancia',
  'Puedo encontrar felicidad',
  'Soy digno de respeto',
  'Mis acciones tienen significado',
  'Puedo crear mi destino',
  'Soy una persona maravillosa',
  'Tengo el poder de la esperanza',
  'Puedo hacer la diferencia',
  'Soy capaz de amar y ser amado',
  'Mis valores me hacen fuerte',
  'Puedo encontrar fuerza',
  'Soy digno de Ã©xito',
  'Tengo el poder de la gratitud',
  'Puedo construir mi futuro',
  'Soy capaz de grandes cosas',
  'Mis sueÃ±os merecen ser perseguidos',
  'Puedo encontrar belleza',
  'Soy digno de amor',
  'Tengo el poder de la compasiÃ³n',
  'Puedo hacer que otros sonrÃ­an',
  'Soy valioso',
  'Mis acciones tienen impacto',
  'Puedo crear momentos',
  'Soy capaz de amar',
  'Tengo el poder de la resiliencia',
  'Puedo encontrar paz',
  'Soy digno de todo',
  'Mis palabras tienen poder',
  'Puedo hacer que cada dÃ­a cuente',
  'Soy una fuente de luz',
  'Tengo el poder de la autenticidad',
  'Puedo inspirar cambios',
  'Soy fuerte',
  'Mis pensamientos crean mi realidad',
  'Puedo hacer que la vida sea hermosa',
  'Soy capaz de amar profundamente',
  'Tengo el poder de la bondad',
  'Puedo encontrar fuerza',
  'Soy digno de respeto',
  'Mis acciones reflejan mi corazÃ³n',
  'Puedo hacer que otros se sientan especiales',
  'Soy una persona Ãºnica',
  'Tengo el poder de la esperanza',
  'Puedo superar',
  'Soy capaz de amar',
  'Mis sueÃ±os merecen ser perseguidos',
  'Puedo encontrar alegrÃ­a',
  'Soy digno de amor',
  'Tengo el poder de la determinaciÃ³n',
  'Puedo crear mi camino',
  'Soy fuerte',
  'Mis palabras pueden sanar',
  'Puedo hacer que otros se sientan bien',
  'Soy capaz de amar sin miedo',
  'Tengo el poder de la fe',
  'Puedo encontrar fuerza',
  'Soy digno de ser amado',
  'Mis acciones tienen propÃ³sito',
  'Puedo hacer que la vida sea especial',
  'Soy una persona de valor',
  'Tengo el poder de la pasiÃ³n',
  'Puedo encontrar significado',
  'Soy capaz de amar',
  'Mis elecciones crean mi futuro',
  'Puedo hacer que cada momento cuente',
  'Soy digno de amor incondicional',
  'Tengo el poder de la creatividad',
  'Puedo superar',
  'Soy fuerte',
  'Mis sueÃ±os merecen ser realidad',
  'Puedo hacer que el mundo sea mejor',
  'Soy capaz de amar',
  'Tengo el poder de la perseverancia',
  'Puedo encontrar felicidad',
  'Soy digno de respeto',
  'Mis acciones tienen significado',
  'Puedo crear mi felicidad',
  'Soy una persona maravillosa',
  'Tengo el poder de la esperanza',
  'Puedo hacer la diferencia',
  'Soy capaz de amar y ser amado',
  'Mis valores me guÃ­an',
  'Puedo encontrar fuerza',
  'Soy digno de Ã©xito',
  'Tengo el poder de la gratitud',
  'Puedo construir mi futuro',
  'Soy capaz',
  'Mis sueÃ±os merecen ser cumplidos',
  'Puedo encontrar belleza',
  'Soy digno de todo lo bueno',
  'Tengo el poder de la determinaciÃ³n',
  'Puedo crear mi destino',
  'Soy fuerte',
  'Mis palabras pueden inspirar',
  'Puedo hacer que otros se sientan valiosos',
  'Soy capaz de amar',
  'Tengo el poder de la fe',
  'Puedo encontrar fuerza',
  'Soy digno de ser amado',
  'Mis acciones tienen propÃ³sito',
  'Puedo hacer que la vida valga la pena',
  'Soy una persona especial',
  'Tengo el poder de la pasiÃ³n',
  'Puedo encontrar significado',
  'Soy capaz de amar',
  'Mis elecciones definen mi camino',
  'Puedo hacer que cada momento sea especial',
  'Soy digno de amor',
  'Tengo el poder de la creatividad',
  'Puedo superar',
  'Soy fuerte',
  'Mis sueÃ±os merecen ser realidad',
  'Puedo hacer que el mundo sea mejor',
  'Soy capaz de amar',
  'Tengo el poder de la perseverancia',
  'Puedo encontrar felicidad',
  'Soy digno de respeto',
  'Mis acciones tienen significado',
  'Puedo crear mi destino',
  'Soy una persona maravillosa',
  'Tengo el poder de la esperanza',
  'Puedo hacer la diferencia',
  'Soy capaz de amar y ser amado',
  'Mis valores me hacen fuerte',
  'Puedo encontrar fuerza',
  'Soy digno de Ã©xito',
  'Tengo el poder de la gratitud',
  'Puedo construir mi futuro',
  'Soy capaz de grandes cosas',
  'Mis sueÃ±os merecen ser perseguidos',
  'Puedo encontrar belleza',
  'Soy digno de amor',
  'Tengo el poder de la compasiÃ³n',
  'Puedo hacer que otros sonrÃ­an',
  'Soy valioso',
  'Mis acciones tienen impacto',
  'Puedo crear momentos',
  'Soy capaz de amar',
  'Tengo el poder de la resiliencia',
  'Puedo encontrar paz',
  'Soy digno de todo',
  'Mis palabras tienen poder',
  'Puedo hacer que cada dÃ­a cuente',
  'Soy una fuente de luz',
  'Tengo el poder de la autenticidad',
  'Puedo inspirar cambios',
  'Soy fuerte',
  'Mis pensamientos crean mi realidad',
  'Puedo hacer que la vida sea hermosa',
  'Soy capaz de amar profundamente',
  'Tengo el poder de la bondad',
  'Puedo encontrar fuerza',
  'Soy digno de respeto',
  'Mis acciones reflejan mi corazÃ³n',
  'Puedo hacer que otros se sientan especiales',
  'Soy una persona Ãºnica',
  'Tengo el poder de la esperanza',
  'Puedo superar',
  'Soy capaz de amar',
  'Mis sueÃ±os merecen ser perseguidos',
  'Puedo encontrar alegrÃ­a',
  'Soy digno de amor',
  'Tengo el poder de la determinaciÃ³n',
  'Puedo crear mi camino',
  'Soy fuerte',
  'Mis palabras pueden sanar',
  'Puedo hacer que otros se sientan bien',
  'Soy capaz de amar sin miedo',
  'Tengo el poder de la fe',
  'Puedo encontrar fuerza',
  'Soy digno de ser amado',
  'Mis acciones tienen propÃ³sito',
  'Puedo hacer que la vida sea especial',
  'Soy una persona de valor',
  'Tengo el poder de la pasiÃ³n',
  'Puedo encontrar significado',
  'Soy capaz de amar',
  'Mis elecciones crean mi futuro',
  'Puedo hacer que cada momento cuente',
  'Soy digno de amor incondicional',
  'Tengo el poder de la creatividad',
  'Puedo superar',
  'Soy fuerte',
  'Mis sueÃ±os merecen ser realidad',
  'Puedo hacer que el mundo sea mejor',
  'Soy capaz de amar',
  'Tengo el poder de la perseverancia',
  'Puedo encontrar felicidad',
  'Soy digno de respeto',
  'Mis acciones tienen significado',
  'Puedo crear mi felicidad',
  'Soy una persona maravillosa',
  'Tengo el poder de la esperanza',
  'Puedo hacer la diferencia',
  'Soy capaz de amar y ser amado',
  'Mis valores me guÃ­an',
  'Puedo encontrar fuerza',
  'Soy digno de Ã©xito',
  'Tengo el poder de la gratitud',
  'Puedo construir mi futuro',
  'Soy capaz',
  'Mis sueÃ±os merecen ser cumplidos',
  'Puedo encontrar belleza',
  'Soy digno de amor',
  'Tengo el poder de la compasiÃ³n',
  'Puedo hacer que otros sonrÃ­an',
  'Soy valioso',
  'Mis acciones tienen impacto',
  'Puedo crear momentos',
  'Soy capaz de amar',
  'Tengo el poder de la resiliencia',
  'Puedo encontrar paz',
  'Soy digno de todo',
  'Mis palabras tienen poder',
  'Puedo hacer que cada dÃ­a cuente',
  'Soy una fuente de luz',
  'Tengo el poder de la autenticidad',
  'Puedo inspirar cambios',
  'Soy fuerte',
  'Mis pensamientos crean mi realidad',
  'Puedo hacer que la vida sea hermosa',
  'Soy capaz de amar profundamente',
  'Tengo el poder de la bondad',
  'Puedo encontrar fuerza',
  'Soy digno de respeto',
  'Mis acciones reflejan mi corazÃ³n',
  'Puedo hacer que otros se sientan especiales',
  'Soy una persona Ãºnica',
  'Tengo el poder de la esperanza',
  'Puedo superar',
  'Soy capaz de amar',
  'Mis sueÃ±os merecen ser perseguidos',
  'Puedo encontrar alegrÃ­a',
  'Soy digno de amor',
  'Tengo el poder de la determinaciÃ³n',
  'Puedo crear mi camino',
  'Soy fuerte',
  'Mis palabras pueden sanar',
  'Puedo hacer que otros se sientan bien',
  'Soy capaz de amar sin miedo',
  'Tengo el poder de la fe',
  'Puedo encontrar fuerza',
  'Soy digno de ser amado',
  'Mis acciones tienen propÃ³sito',
  'Puedo hacer que la vida sea especial',
  'Soy una persona de valor',
  'Tengo el poder de la pasiÃ³n',
  'Puedo encontrar significado',
  'Soy capaz de amar',
  'Mis elecciones crean mi futuro',
  'Puedo hacer que cada momento cuente',
  'Soy digno de amor incondicional',
  'Tengo el poder de la creatividad',
  'Puedo superar',
  'Soy fuerte',
  'Mis sueÃ±os merecen ser realidad',
  'Puedo hacer que el mundo sea mejor',
  'Soy capaz de amar',
  'Tengo el poder de la perseverancia',
  'Puedo encontrar felicidad',
  'Soy digno de respeto',
  'Mis acciones tienen significado',
  'Puedo crear mi destino',
  'Soy una persona maravillosa',
  'Tengo el poder de la esperanza',
  'Puedo hacer la diferencia',
  'Soy capaz de amar y ser amado',
  'Mis valores me hacen fuerte',
  'Puedo encontrar fuerza',
  'Soy digno de Ã©xito',
  'Tengo el poder de la gratitud',
  'Puedo construir mi futuro',
  'Soy capaz de grandes cosas',
  'Mis sueÃ±os merecen ser perseguidos',
  'Puedo encontrar belleza',
  'Soy digno de amor',
  'Tengo el poder de la compasiÃ³n',
  'Puedo hacer que otros sonrÃ­an',
  'Soy valioso',
  'Mis acciones tienen impacto',
  'Puedo crear momentos',
  'Soy capaz de amar',
  'Tengo el poder de la resiliencia',
  'Puedo encontrar paz',
  'Soy digno de todo',
  'Mis palabras tienen poder',
  'Puedo hacer que cada dÃ­a cuente',
  'Soy una fuente de luz',
  'Tengo el poder de la autenticidad',
  'Puedo inspirar cambios',
  'Soy fuerte',
  'Mis pensamientos crean mi realidad',
  'Puedo hacer que la vida sea hermosa',
  'Soy capaz de amar profundamente',
  'Tengo el poder de la bondad',
  'Puedo encontrar fuerza',
  'Soy digno de respeto',
  'Mis acciones reflejan mi corazÃ³n',
  'Puedo hacer que otros se sientan especiales',
  'Soy una persona Ãºnica',
  'Tengo el poder de la esperanza',
  'Puedo superar',
  'Soy capaz de amar',
  'Mis sueÃ±os merecen ser perseguidos',
  'Puedo encontrar alegrÃ­a',
  'Soy digno de amor',
  'Tengo el poder de la determinaciÃ³n',
  'Puedo crear mi camino',
  'Soy fuerte',
  'Mis palabras pueden sanar',
  'Puedo hacer que otros se sientan bien',
  'Soy capaz de amar sin miedo',
  'Tengo el poder de la fe',
  'Puedo encontrar fuerza',
  'Soy digno de ser amado',
  'Mis acciones tienen propÃ³sito',
  'Puedo hacer que la vida sea especial',
  'Soy una persona de valor',
  'Tengo el poder de la pasiÃ³n',
  'Puedo encontrar significado',
  'Soy capaz de amar',
  'Mis elecciones crean mi futuro',
  'Puedo hacer que cada momento cuente',
  'Soy digno de amor incondicional',
  'Tengo el poder de la creatividad',
  'Puedo superar',
  'Soy fuerte',
  'Mis sueÃ±os merecen ser realidad',
  'Puedo hacer que el mundo sea mejor',
  'Soy capaz de amar',
  'Tengo el poder de la perseverancia',
  'Puedo encontrar felicidad',
  'Soy digno de respeto',
  'Mis acciones tienen significado',
  'Puedo crear mi destino',
  'Soy una persona maravillosa',
  'Tengo el poder de la esperanza',
  'Puedo hacer la diferencia',
  'Soy capaz de amar y ser amado',
  'Mis valores me hacen fuerte',
  'Puedo encontrar fuerza',
  'Soy digno de Ã©xito',
  'Tengo el poder de la gratitud',
  'Puedo construir mi futuro',
  'Soy capaz',
  'Mis sueÃ±os merecen ser cumplidos',
  'Puedo encontrar belleza',
  'Soy digno de todo lo bueno',
  'Tengo el poder de la determinaciÃ³n',
  'Puedo crear mi destino',
  'Soy fuerte',
  'Mis palabras pueden inspirar',
  'Puedo hacer que otros se sientan valiosos',
  'Soy capaz de amar',
  'Tengo el poder de la fe',
  'Puedo encontrar fuerza',
  'Soy digno de ser amado',
  'Mis acciones tienen propÃ³sito',
  'Puedo hacer que la vida valga la pena',
  'Soy una persona especial',
  'Tengo el poder de la pasiÃ³n',
  'Puedo encontrar significado',
  'Soy capaz de amar',
  'Mis elecciones definen mi camino',
  'Puedo hacer que cada momento sea especial',
  'Soy digno de amor',
  'Tengo el poder de la creatividad',
  'Puedo superar',
  'Soy fuerte',
  'Mis sueÃ±os merecen ser realidad',
  'Puedo hacer que el mundo sea mejor',
  'Soy capaz de amar',
  'Tengo el poder de la perseverancia',
  'Puedo encontrar felicidad',
  'Soy digno de respeto',
  'Mis acciones tienen significado',
  'Puedo crear mi destino',
  'Soy una persona maravillosa',
  'Tengo el poder de la esperanza',
  'Puedo hacer la diferencia',
  'Soy capaz de amar y ser amado',
  'Mis valores me guÃ­an',
  'Puedo encontrar fuerza',
  'Soy digno de Ã©xito',
  'Tengo el poder de la gratitud',
  'Puedo construir mi futuro',
  'Soy capaz',
  'Mis sueÃ±os merecen ser cumplidos',
  'Puedo encontrar belleza',
  'Soy digno de amor',
  'Tengo el poder de la compasiÃ³n',
  'Puedo hacer que otros sonrÃ­an',
  'Soy valioso',
  'Mis acciones tienen impacto',
  'Puedo crear momentos',
  'Soy capaz de amar',
  'Tengo el poder de la resiliencia',
  'Puedo encontrar paz',
  'Soy digno de todo',
  'Mis palabras tienen poder',
  'Puedo hacer que cada dÃ­a cuente',
  'Soy una fuente de luz',
  'Tengo el poder de la autenticidad',
  'Puedo inspirar cambios',
  'Soy fuerte',
  'Mis pensamientos crean mi realidad',
  'Puedo hacer que la vida sea hermosa',
  'Soy capaz de amar profundamente',
  'Tengo el poder de la bondad',
  'Puedo encontrar fuerza',
  'Soy digno de respeto',
  'Mis acciones reflejan mi corazÃ³n',
  'Puedo hacer que otros se sientan especiales',
  'Soy una persona Ãºnica',
  'Tengo el poder de la esperanza',
  'Puedo superar',
  'Soy capaz de amar',
  'Mis sueÃ±os merecen ser perseguidos',
  'Puedo encontrar alegrÃ­a',
  'Soy digno de amor',
  'Tengo el poder de la determinaciÃ³n',
  'Puedo crear mi camino',
  'Soy fuerte',
  'Mis palabras pueden sanar',
  'Puedo hacer que otros se sientan bien',
  'Soy capaz de amar sin miedo',
  'Tengo el poder de la fe',
  'Puedo encontrar fuerza',
  'Soy digno de ser amado',
  'Mis acciones tienen propÃ³sito',
  'Puedo hacer que la vida sea especial',
  'Soy una persona de valor',
  'Tengo el poder de la pasiÃ³n',
  'Puedo encontrar significado',
  'Soy capaz de amar',
  'Mis elecciones crean mi futuro',
  'Puedo hacer que cada momento cuente',
  'Soy digno de amor incondicional',
  'Tengo el poder de la creatividad',
  'Puedo superar',
  'Soy fuerte',
  'Mis sueÃ±os merecen ser realidad',
  'Puedo hacer que el mundo sea mejor',
  'Soy capaz de amar',
  'Tengo el poder de la perseverancia',
  'Puedo encontrar felicidad',
  'Soy digno de respeto',
  'Mis acciones tienen significado',
  'Puedo crear mi destino',
  'Soy una persona maravillosa',
  'Tengo el poder de la esperanza',
  'Puedo hacer la diferencia',
  'Soy capaz de amar y ser amado',
  'Mis valores me guÃ­an',
  'Puedo encontrar fuerza',
  'Soy digno de Ã©xito',
  'Tengo el poder de la gratitud',
  'Puedo construir mi futuro',
  'Soy capaz',
  'Mis sueÃ±os merecen ser cumplidos',
  'Puedo encontrar belleza',
  'Soy digno de amor',
  'Tengo el poder de la compasiÃ³n',
  'Puedo hacer que otros sonrÃ­an',
  'Soy valioso',
  'Mis acciones tienen impacto',
  'Puedo crear momentos',
  'Soy capaz de amar',
  'Tengo el poder de la resiliencia',
  'Puedo encontrar paz',
  'Soy digno de todo',
  'Mis palabras tienen poder',
  'Puedo hacer que cada dÃ­a cuente',
  'Soy una fuente de luz',
  'Tengo el poder de la autenticidad',
  'Puedo inspirar cambios',
  'Soy fuerte',
  'Mis pensamientos crean mi realidad',
  'Puedo hacer que la vida sea hermosa',
  'Soy capaz de amar profundamente',
  'Tengo el poder de la bondad',
  'Puedo encontrar fuerza',
  'Soy digno de respeto',
  'Mis acciones reflejan mi corazÃ³n',
  'Puedo hacer que otros se sientan especiales',
  'Soy una persona Ãºnica',
  'Tengo el poder de la esperanza',
  'Puedo superar',
  'Soy capaz de amar',
  'Mis sueÃ±os merecen ser perseguidos',
  'Puedo encontrar alegrÃ­a',
  'Soy digno de amor',
  'Tengo el poder de la determinaciÃ³n',
  'Puedo crear mi camino',
  'Soy fuerte',
  'Mis palabras pueden sanar',
  'Puedo hacer que otros se sientan bien',
  'Soy capaz de amar sin miedo',
  'Tengo el poder de la fe',
  'Puedo encontrar fuerza',
  'Soy digno de ser amado',
  'Mis acciones tienen propÃ³sito',
  'Puedo hacer que la vida sea especial',
  'Soy una persona de valor',
  'Tengo el poder de la pasiÃ³n',
  'Puedo encontrar significado',
  'Soy capaz de amar',
  'Mis elecciones crean mi futuro',
  'Puedo hacer que cada momento cuente',
  'Soy digno de amor incondicional',
  'Tengo el poder de la creatividad',
  'Puedo superar',
  'Soy fuerte',
  'Mis sueÃ±os merecen ser realidad',
  'Puedo hacer que el mundo sea mejor',
  'Soy capaz de amar',
  'Tengo el poder de la perseverancia',
  'Puedo encontrar felicidad',
  'Soy digno de respeto',
  'Mis acciones tienen significado',
  'Puedo crear mi destino',
  'Soy una persona maravillosa',
  'Tengo el poder de la esperanza',
  'Puedo hacer la diferencia',
  'Soy capaz de amar y ser amado',
  'Mis valores me guÃ­an',
  'Puedo encontrar fuerza',
  'Soy digno de Ã©xito',
  'Tengo el poder de la gratitud',
  'Puedo construir mi futuro',
  'Soy capaz',
  'Mis sueÃ±os merecen ser cumplidos',
  'Puedo encontrar belleza',
  'Soy digno de amor',
  'Tengo el poder de la compasiÃ³n',
  'Puedo hacer que otros sonrÃ­an',
  'Soy valioso',
  'Mis acciones tienen impacto',
  'Puedo crear momentos',
  'Soy capaz de amar',
  'Tengo el poder de la resiliencia',
  'Puedo encontrar paz',
  'Soy digno de todo',
  'Mis palabras tienen poder',
  'Puedo hacer que cada dÃ­a cuente',
  'Soy una fuente de luz',
  'Tengo el poder de la autenticidad',
  'Puedo inspirar cambios',
  'Soy fuerte',
  'Mis pensamientos crean mi realidad',
  'Puedo hacer que la vida sea hermosa',
  'Soy capaz de amar profundamente',
  'Tengo el poder de la bondad',
  'Puedo encontrar fuerza',
  'Soy digno de respeto',
  'Mis acciones reflejan mi corazÃ³n',
  'Puedo hacer que otros se sientan especiales',
  'Soy una persona Ãºnica',
  'Tengo el poder de la esperanza',
  'Puedo superar',
  'Soy capaz de amar',
  'Mis sueÃ±os merecen ser perseguidos',
  'Puedo encontrar alegrÃ­a',
  'Soy digno de amor',
  'Tengo el poder de la determinaciÃ³n',
  'Puedo crear mi camino',
  'Soy fuerte',
  'Mis palabras pueden sanar',
  'Puedo hacer que otros se sientan bien',
  'Soy capaz de amar sin miedo',
  'Tengo el poder de la fe',
  'Puedo encontrar fuerza',
  'Soy digno de ser amado',
  'Mis acciones tienen propÃ³sito',
  'Puedo hacer que la vida sea especial',
  'Soy una persona de valor',
  'Tengo el poder de la pasiÃ³n',
  'Puedo encontrar significado',
  'Soy capaz de amar',
  'Mis elecciones crean mi futuro',
  'Puedo hacer que cada momento cuente',
  'Soy digno de amor incondicional',
  'Tengo el poder de la creatividad',
  'Puedo superar',
  'Soy fuerte',
  'Mis sueÃ±os merecen ser realidad',
  'Puedo hacer que el mundo sea mejor',
  'Soy capaz de amar',
  'Tengo el poder de la perseverancia',
  'Puedo encontrar felicidad',
  'Soy digno de respeto',
  'Mis acciones tienen significado',
  'Puedo crear mi destino',
  'Soy una persona maravillosa',
  'Tengo el poder de la esperanza',
  'Puedo hacer la diferencia',
  'Soy capaz de amar y ser amado',
  'Mis valores me guÃ­an',
  'Puedo encontrar fuerza',
  'Soy digno de Ã©xito',
  'Tengo el poder de la gratitud',
  'Puedo construir mi futuro',
  'Soy capaz',
  'Mis sueÃ±os merecen ser cumplidos',
  'Puedo encontrar belleza',
  'Soy digno de amor',
  'Tengo el poder de la compasiÃ³n',
  'Puedo hacer que otros sonrÃ­an',
  'Soy valioso',
  'Mis acciones tienen impacto',
  'Puedo crear momentos',
  'Soy capaz de amar',
  'Tengo el poder de la resiliencia',
  'Puedo encontrar paz',
  'Soy digno de todo',
  'Mis palabras tienen poder',
  'Puedo hacer que cada dÃ­a cuente',
  'Soy una fuente de luz',
  'Tengo el poder de la autenticidad',
  'Puedo inspirar cambios',
  'Soy fuerte',
  'Mis pensamientos crean mi realidad',
  'Puedo hacer que la vida sea hermosa',
  'Soy capaz de amar profundamente',
  'Tengo el poder de la bondad',
  'Puedo encontrar fuerza',
  'Soy digno de respeto',
  'Mis acciones reflejan mi corazÃ³n',
  'Puedo hacer que otros se sientan especiales',
  'Soy una persona Ãºnica',
  'Tengo el poder de la esperanza',
  'Puedo superar',
  'Soy capaz de amar',
  'Mis sueÃ±os merecen ser perseguidos',
  'Puedo encontrar alegrÃ­a',
  'Soy digno de amor',
  'Tengo el poder de la determinaciÃ³n',
  'Puedo crear mi camino',
  'Soy fuerte',
  'Mis palabras pueden sanar',
  'Puedo hacer que otros se sientan bien',
  'Soy capaz de amar sin miedo',
  'Tengo el poder de la fe',
  'Puedo encontrar fuerza',
  'Soy digno de ser amado',
  'Mis acciones tienen propÃ³sito',
  'Puedo hacer que la vida sea especial',
  'Soy una persona de valor',
  'Tengo el poder de la pasiÃ³n',
  'Puedo encontrar significado',
  'Soy capaz de amar',
  'Mis elecciones crean mi futuro',
  'Puedo hacer que cada momento cuente',
  'Soy digno de amor incondicional',
  'Tengo el poder de la creatividad',
  'Puedo superar',
  'Soy fuerte',
  'Mis sueÃ±os merecen ser realidad',
  'Puedo hacer que el mundo sea mejor',
  'Soy capaz de amar',
  'Tengo el poder de la perseverancia',
  'Puedo encontrar felicidad',
  'Soy digno de respeto',
  'Mis acciones tienen significado',
  'Puedo crear mi destino',
  'Soy una persona maravillosa',
  'Tengo el poder de la esperanza',
  'Puedo hacer la diferencia',
  'Soy capaz de amar y ser amado',
  'Mis valores me guÃ­an',
  'Puedo encontrar fuerza',
  'Soy digno de Ã©xito',
  'Tengo el poder de la gratitud',
  'Puedo construir mi futuro',
  'Soy capaz',
  'Mis sueÃ±os merecen ser cumplidos',
  'Puedo encontrar belleza',
  'Soy digno de amor',
  'Tengo el poder de la compasiÃ³n',
  'Puedo hacer que otros sonrÃ­an',
  'Soy valioso',
  'Mis acciones tienen impacto',
  'Puedo crear momentos',
  'Soy capaz de amar',
  'Tengo el poder de la resiliencia',
  'Puedo encontrar paz',
  'Soy digno de todo',
  'Mis palabras tienen poder',
  'Puedo hacer que cada dÃ­a cuente',
  'Soy una fuente de luz',
  'Tengo el poder de la autenticidad',
  'Puedo inspirar cambios',
  'Soy fuerte',
  'Mis pensamientos crean mi realidad',
  'Puedo hacer que la vida sea hermosa',
  'Soy capaz de amar profundamente',
  'Tengo el poder de la bondad',
  'Puedo encontrar fuerza',
  'Soy digno de respeto',
  'Mis acciones reflejan mi corazÃ³n',
  'Puedo hacer que otros se sientan especiales',
  'Soy una persona Ãºnica',
  'Tengo el poder de la esperanza',
  'Puedo superar',
  'Soy capaz de amar',
  'Mis sueÃ±os merecen ser perseguidos',
  'Puedo encontrar alegrÃ­a',
  'Soy digno de amor',
  'Tengo el poder de la determinaciÃ³n',
  'Puedo crear mi camino',
  'Soy fuerte',
  'Mis palabras pueden sanar',
  'Puedo hacer que otros se sientan bien',
  'Soy capaz de amar sin miedo',
  'Tengo el poder de la fe',
  'Puedo encontrar fuerza',
  'Soy digno de ser amado',
  'Mis acciones tienen propÃ³sito',
  'Puedo hacer que la vida sea especial',
  'Soy una persona de valor',
  'Tengo el poder de la pasiÃ³n',
  'Puedo encontrar significado',
  'Soy capaz de amar',
  'Mis elecciones crean mi futuro',
  'Puedo hacer que cada momento cuente',
  'Soy digno de amor incondicional',
  'Tengo el poder de la creatividad',
  'Puedo superar',
  'Soy fuerte',
  'Mis sueÃ±os merecen ser realidad',
  'Puedo hacer que el mundo sea mejor',
  'Soy capaz de amar',
  'Tengo el poder de la perseverancia',
  'Puedo encontrar felicidad',
  'Soy digno de respeto',
  'Mis acciones tienen significado',
  'Puedo crear mi destino',
  'Soy una persona maravillosa',
  'Tengo el poder de la esperanza',
  'Puedo hacer la diferencia',
  'Soy capaz de amar y ser amado',
  'Mis valores me guÃ­an',
  'Puedo encontrar fuerza',
  'Soy digno de Ã©xito',
  'Tengo el poder de la gratitud',
  'Puedo construir mi futuro',
  'Soy capaz',
  'Mis sueÃ±os merecen ser cumplidos',
  'Puedo encontrar belleza',
  'Soy digno de amor',
  'Tengo el poder de la compasiÃ³n',
  'Puedo hacer que otros sonrÃ­an',
  'Soy valioso',
  'Mis acciones tienen impacto',
  'Puedo crear momentos',
  'Soy capaz de amar',
  'Tengo el poder de la resiliencia',
  'Puedo encontrar paz',
  'Soy digno de todo',
  'Mis palabras tienen poder',
  'Puedo hacer que cada dÃ­a cuente',
  'Soy una fuente de luz',
  'Tengo el poder de la autenticidad',
  'Puedo inspirar cambios',
  'Soy fuerte',
  'Mis pensamientos crean mi realidad',
  'Puedo hacer que la vida sea hermosa',
  'Soy capaz de amar profundamente',
  'Tengo el poder de la bondad',
  'Puedo encontrar fuerza',
  'Soy digno de respeto',
  'Mis acciones reflejan mi corazÃ³n',
  'Puedo hacer que otros se sientan especiales',
  'Soy una persona Ãºnica',
  'Tengo el poder de la esperanza',
  'Puedo superar',
  'Soy capaz de amar',
  'Mis sueÃ±os merecen ser perseguidos',
  'Puedo encontrar alegrÃ­a',
  'Soy digno de amor',
  'Tengo el poder de la determinaciÃ³n',
  'Puedo crear mi camino',
  'Soy fuerte',
  'Mis palabras pueden sanar',
  'Puedo hacer que otros se sientan bien',
  'Soy capaz de amar sin miedo',
  'Tengo el poder de la fe',
  'Puedo encontrar fuerza',
  'Soy digno de ser amado',
  'Mis acciones tienen propÃ³sito',
  'Puedo hacer que la vida sea especial',
  'Soy una persona de valor',
  'Tengo el poder de la pasiÃ³n',
  'Puedo encontrar significado',
  'Soy capaz de amar',
  'Mis elecciones crean mi futuro',
  'Puedo hacer que cada momento cuente',
  'Soy digno de amor incondicional',
  'Tengo el poder de la creatividad',
  'Puedo superar',
  'Soy fuerte',
  'Mis sueÃ±os merecen ser realidad',
  'Puedo hacer que el mundo sea mejor',
  'Soy capaz de amar',
  'Tengo el poder de la perseverancia',
  'Puedo encontrar felicidad',
  'Soy digno de respeto',
  'Mis acciones tienen significado',
  'Puedo crear mi destino',
  'Soy una persona maravillosa',
  'Tengo el poder de la esperanza',
  'Puedo hacer la diferencia',
  'Soy capaz de amar y ser amado',
  'Mis valores me guÃ­an',
  'Puedo encontrar fuerza',
  'Soy digno de Ã©xito',
  'Tengo el poder de la gratitud',
  'Puedo construir mi futuro',
  'Soy capaz',
  'Mis sueÃ±os merecen ser cumplidos',
  'Puedo encontrar belleza',
  'Soy digno de amor',
  'Tengo el poder de la compasiÃ³n',
  'Puedo hacer que otros sonrÃ­an',
  'Soy valioso',
  'Mis acciones tienen impacto',
  'Puedo crear momentos',
  'Soy capaz de amar',
  'Tengo el poder de la resiliencia',
  'Puedo encontrar paz',
  'Soy digno de todo',
  'Mis palabras tienen poder',
  'Puedo hacer que cada dÃ­a cuente',
  'Soy una fuente de luz',
  'Tengo el poder de la autenticidad',
  'Puedo inspirar cambios',
  'Soy fuerte',
  'Mis pensamientos crean mi realidad',
  'Puedo hacer que la vida sea hermosa',
  'Soy capaz de amar profundamente',
  'Tengo el poder de la bondad',
  'Puedo encontrar fuerza',
  'Soy digno de respeto',
  'Mis acciones reflejan mi corazÃ³n',
  'Puedo hacer que otros se sientan especiales',
  'Soy una persona Ãºnica',
  'Tengo el poder de la esperanza',
  'Puedo superar',
  'Soy capaz de amar',
  'Mis sueÃ±os merecen ser perseguidos',
  'Puedo encontrar alegrÃ­a',
  'Soy digno de amor',
  'Tengo el poder de la determinaciÃ³n',
  'Puedo crear mi camino',
  'Soy fuerte',
  'Mis palabras pueden sanar',
  'Puedo hacer que otros se sientan bien',
  'Soy capaz de amar sin miedo',
  'Tengo el poder de la fe',
  'Puedo encontrar fuerza',
  'Soy digno de ser amado',
  'Mis acciones tienen propÃ³sito',
  'Puedo hacer que la vida sea especial',
  'Soy una persona de valor',
  'Tengo el poder de la pasiÃ³n',
  'Puedo encontrar significado',
  'Soy capaz de amar',
  'Mis elecciones crean mi futuro',
  'Puedo hacer que cada momento cuente',
  'Soy digno de amor incondicional',
  'Tengo el poder de la creatividad',
  'Puedo superar',
  'Soy fuerte',
  'Mis sueÃ±os merecen ser realidad',
  'Puedo hacer que el mundo sea mejor',
  'Soy capaz de amar',
  'Tengo el poder de la perseverancia',
  'Puedo encontrar felicidad',
  'Soy digno de respeto',
  'Mis acciones tienen significado',
  'Puedo crear mi destino',
  'Soy una persona maravillosa',
  'Tengo el poder de la esperanza',
  'Puedo hacer la diferencia',
  'Soy capaz de amar y ser amado',
  'Mis valores me guÃ­an',
  'Puedo encontrar fuerza',
  'Soy digno de Ã©xito',
  'Tengo el poder de la gratitud',
  'Puedo construir mi futuro',
  'Soy capaz',
  'Mis sueÃ±os merecen ser cumplidos',
  'Puedo encontrar belleza',
  'Soy digno de amor',
  'Tengo el poder de la compasiÃ³n',
  'Puedo hacer que otros sonrÃ­an',
  'Soy valioso',
  'Mis acciones tienen impacto',
  'Puedo crear momentos',
  'Soy capaz de amar',
  'Tengo el poder de la resiliencia',
  'Puedo encontrar paz',
  'Soy digno de todo',
  'Mis palabras tienen poder',
  'Puedo hacer que cada dÃ­a cuente',
  'Soy una fuente de luz',
  'Tengo el poder de la autenticidad',
  'Puedo inspirar cambios',
  'Soy fuerte',
  'Mis pensamientos crean mi realidad',
  'Puedo hacer que la vida sea hermosa',
  'Soy capaz de amar profundamente',
  'Tengo el poder de la bondad',
  'Puedo encontrar fuerza',
  'Soy digno de respeto',
  'Mis acciones reflejan mi corazÃ³n',
  'Puedo hacer que otros se sientan especiales',
  'Soy una persona Ãºnica',
  'Tengo el poder de la esperanza',
  'Puedo superar',
  'Soy capaz de amar',
  'Mis sueÃ±os merecen ser perseguidos',
  'Puedo encontrar alegrÃ­a',
  'Soy digno de amor',
  'Tengo el poder de la determinaciÃ³n',
  'Puedo crear mi camino',
  'Soy fuerte',
  'Mis palabras pueden sanar',
  'Puedo hacer que otros se sientan bien',
  'Soy capaz de amar sin miedo',
  'Tengo el poder de la fe',
  'Puedo encontrar fuerza',
  'Soy digno de ser amado',
  'Mis acciones tienen propÃ³sito',
  'Puedo hacer que la vida sea especial',
  'Soy una persona de valor',
  'Tengo el poder de la pasiÃ³n',
  'Puedo encontrar significado',
  'Soy capaz de amar',
  'Mis elecciones crean mi futuro',
  'Puedo hacer que cada momento cuente',
  'Soy digno de amor incondicional',
  'Tengo el poder de la creatividad',
  'Puedo superar',
  'Soy fuerte',
  'Mis sueÃ±os merecen ser realidad',
  'Puedo hacer que el mundo sea mejor',
  'Soy capaz de amar',
  'Tengo el poder de la perseverancia',
  'Puedo encontrar felicidad',
  'Soy digno de respeto',
  'Mis acciones tienen significado',
  'Puedo crear mi destino',
  'Soy una persona maravillosa',
  'Tengo el poder de la esperanza',
  'Puedo hacer la diferencia',
  'Soy capaz de amar y ser amado',
  'Mis valores me guÃ­an',
  'Puedo encontrar fuerza',
  'Soy digno de Ã©xito',
  'Tengo el poder de la gratitud',
  'Puedo construir mi futuro',
  'Soy capaz',
  'Mis sueÃ±os merecen ser cumplidos',
  'Puedo encontrar belleza',
  'Soy digno de amor',
  'Tengo el poder de la compasiÃ³n',
  'Puedo hacer que otros sonrÃ­an',
  'Soy valioso',
  'Mis acciones tienen impacto',
  'Puedo crear momentos',
  'Soy capaz de amar',
  'Tengo el poder de la resiliencia',
  'Puedo encontrar paz',
  'Soy digno de todo',
  'Mis palabras tienen poder',
  'Puedo hacer que cada dÃ­a cuente',
  'Soy una fuente de luz',
  'Tengo el poder de la autenticidad',
  'Puedo inspirar cambios',
  'Soy fuerte',
  'Mis pensamientos crean mi realidad',
  'Puedo hacer que la vida sea hermosa',
  'Soy capaz de amar profundamente',
  'Tengo el poder de la bondad',
  'Puedo encontrar fuerza',
  'Soy digno de respeto',
  'Mis acciones reflejan mi corazÃ³n',
  'Puedo hacer que otros se sientan especiales',
  'Soy una persona Ãºnica',
  'Tengo el poder de la esperanza',
  'Puedo superar',
  'Soy capaz de amar',
  'Mis sueÃ±os merecen ser perseguidos',
  'Puedo encontrar alegrÃ­a',
  'Soy digno de amor',
  'Tengo el poder de la determinaciÃ³n',
  'Puedo crear mi camino',
  'Soy fuerte',
  'Mis palabras pueden sanar',
  'Puedo hacer que otros se sientan bien',
  'Soy capaz de amar sin miedo',
  'Tengo el poder de la fe',
  'Puedo encontrar fuerza',
  'Soy digno de ser amado',
  'Mis acciones tienen propÃ³sito',
  'Puedo hacer que la vida sea especial',
  'Soy una persona de valor',
  'Tengo el poder de la pasiÃ³n',
  'Puedo encontrar significado',
  'Soy capaz de amar',
  'Mis elecciones crean mi futuro',
  'Puedo hacer que cada momento cuente',
  'Soy digno de amor incondicional',
  'Tengo el poder de la creatividad',
  'Puedo superar',
  'Soy fuerte',
  'Mis sueÃ±os merecen ser realidad',
  'Puedo hacer que el mundo sea mejor',
  'Soy capaz de amar',
  'Tengo el poder de la perseverancia',
  'Puedo encontrar felicidad',
  'Soy digno de respeto',
  'Mis acciones tienen significado',
  'Puedo crear mi destino',
  'Soy una persona maravillosa',
  'Tengo el poder de la esperanza',
  'Puedo hacer la diferencia',
  'Soy capaz de amar y ser amado',
  'Mis valores me guÃ­an',
  'Puedo encontrar fuerza',
  'Soy digno de Ã©xito',
  'Tengo el poder de la gratitud',
  'Puedo construir mi futuro',
  'Soy capaz',
  'Mis sueÃ±os merecen ser perseguidos',
  'Puedo encontrar belleza',
  'Soy digno de amor',
  'Tengo el poder de la compasiÃ³n',
  'Puedo hacer que otros sonrÃ­an',
  'Soy valioso',
  'Mis acciones tienen impacto',
  'Puedo crear momentos',
  'Soy capaz de amar',
  'Tengo el poder de la resiliencia',
  'Puedo encontrar paz',
  'Soy digno de todo',
  'Mis palabras tienen poder',
  'Puedo hacer que cada dÃ­a cuente',
  'Soy una fuente de luz',
  'Tengo el poder de la autenticidad',
  'Puedo inspirar cambios',
  'Soy fuerte',
  'Mis pensamientos crean mi realidad',
  'Puedo hacer que la vida sea hermosa',
  'Soy capaz de amar profundamente',
  'Tengo el poder de la bondad',
  'Puedo encontrar fuerza',
  'Soy digno de respeto',
  'Mis acciones reflejan mi corazÃ³n',
  'Puedo hacer que otros se sientan especiales',
  'Soy una persona Ãºnica',
  'Tengo el poder de la esperanza',
  'Puedo superar',
  'Soy capaz de amar',
  'Mis sueÃ±os merecen ser perseguidos',
  'Puedo encontrar alegrÃ­a',
  'Soy digno de amor',
  'Tengo el poder de la determinaciÃ³n',
  'Puedo crear mi camino',
  'Soy fuerte',
  'Mis palabras pueden sanar',
  'Puedo hacer que otros se sientan bien',
  'Soy capaz de amar sin miedo',
  'Tengo el poder de la fe',
  'Puedo encontrar fuerza',
  'Soy digno de ser amado',
  'Mis acciones tienen propÃ³sito',
  'Puedo hacer que la vida sea especial',
  'Soy una persona de valor',
  'Tengo el poder de la pasiÃ³n',
  'Puedo encontrar significado',
  'Soy capaz de amar',
  'Mis elecciones crean mi futuro',
  'Puedo hacer que cada momento cuente',
  'Soy digno de amor incondicional',
  'Tengo el poder de la creatividad',
  'Puedo superar',
  'Soy fuerte',
  'Mis sueÃ±os merecen ser realidad',
  'Puedo hacer que el mundo sea mejor',
  'Soy capaz de amar',
  'Tengo el poder de la perseverancia',
  'Puedo encontrar felicidad',
  'Soy digno de respeto',
  'Mis acciones tienen significado',
  'Puedo crear mi destino',
  'Soy una persona maravillosa',
  'Tengo el poder de la esperanza',
  'Puedo hacer la diferencia',
  'Soy capaz de amar y ser amado',
  'Mis valores me guÃ­an',
  'Puedo encontrar fuerza',
  'Soy digno de Ã©xito',
  'Tengo el poder de la gratitud',
  'Puedo construir mi futuro',
  'Soy capaz',
  'Mis sueÃ±os merecen ser cumplidos',
  'Puedo encontrar belleza',
  'Soy digno de amor',
  'Tengo el poder de la compasiÃ³n',
  'Puedo hacer que otros sonrÃ­an',
  'Soy valioso',
  'Mis acciones tienen impacto',
  'Puedo crear momentos',
  'Soy capaz de amar',
  'Tengo el poder de la resiliencia',
  'Puedo encontrar paz',
  'Soy digno de todo',
  'Mis palabras tienen poder',
  'Puedo hacer que cada dÃ­a cuente',
  'Soy una fuente de luz',
  'Tengo el poder de la autenticidad',
  'Puedo inspirar cambios',
  'Soy fuerte',
  'Mis pensamientos crean mi realidad',
  'Puedo hacer que la vida sea hermosa',
  'Soy capaz de amar profundamente',
  'Tengo el poder de la bondad',
  'Puedo encontrar fuerza',
  'Soy digno de respeto',
  'Mis acciones reflejan mi corazÃ³n',
  'Puedo hacer que otros se sientan especiales',
  'Soy una persona Ãºnica',
  'Tengo el poder de la esperanza',
  'Puedo superar',
  'Soy capaz de amar',
  'Mis sueÃ±os merecen ser perseguidos',
  'Puedo encontrar alegrÃ­a',
  'Soy digno de amor',
  'Tengo el poder de la determinaciÃ³n',
  'Puedo crear mi camino',
  'Soy fuerte',
  'Mis palabras pueden sanar',
  'Puedo hacer que otros se sientan bien',
  'Soy capaz de amar sin miedo',
  'Tengo el poder de la fe',
  'Puedo encontrar fuerza',
  'Soy digno de ser amado',
  'Mis acciones tienen propÃ³sito',
  'Puedo hacer que la vida sea especial',
  'Soy una persona de valor',
  'Tengo el poder de la pasiÃ³n',
  'Puedo encontrar significado',
  'Soy capaz de amar',
  'Mis elecciones crean mi futuro',
  'Puedo hacer que cada momento cuente',
  'Soy digno de amor incondicional',
  'Tengo el poder de la creatividad',
  'Puedo superar',
  'Soy fuerte',
  'Mis sueÃ±os merecen ser realidad',
  'Puedo hacer que el mundo sea mejor',
  'Soy capaz de amar',
  'Tengo el poder de la perseverancia',
  'Puedo encontrar felicidad',
  'Soy digno de respeto',
  'Mis acciones tienen significado',
  'Puedo crear mi destino',
  'Soy una persona maravillosa',
  'Tengo el poder de la esperanza',
  'Puedo hacer la diferencia',
  'Soy capaz de amar y ser amado',
  'Mis valores me guÃ­an',
  'Puedo encontrar fuerza',
  'Soy digno de Ã©xito',
  'Tengo el poder de la gratitud',
  'Puedo construir mi futuro',
  'Soy capaz',
  'Mis sueÃ±os merecen ser perseguidos',
  'Puedo encontrar belleza',
  'Soy digno de amor',
  'Tengo el poder de la compasiÃ³n',
  'Puedo hacer que otros sonrÃ­an',
  'Soy valioso',
  'Mis acciones tienen impacto',
  'Puedo crear momentos',
  'Soy capaz de amar',
  'Tengo el poder de la resiliencia',
  'Puedo encontrar paz',
  'Soy digno de todo',
  'Mis palabras tienen poder',
  'Puedo hacer que cada dÃ­a cuente',
  'Soy una fuente de luz',
  'Tengo el poder de la autenticidad',
  'Puedo inspirar cambios',
  'Soy fuerte',
  'Mis pensamientos crean mi realidad',
  'Puedo hacer que la vida sea hermosa',
  'Soy capaz de amar profundamente',
  'Tengo el poder de la bondad',
  'Puedo encontrar fuerza',
  'Soy digno de respeto',
  'Mis acciones reflejan mi corazÃ³n',
  'Puedo hacer que otros se sientan especiales',
  'Soy una persona Ãºnica',
  'Tengo el poder de la esperanza',
  'Puedo superar',
  'Soy capaz de amar',
  'Mis sueÃ±os merecen ser perseguidos',
  'Puedo encontrar alegrÃ­a',
  'Soy digno de amor',
  'Tengo el poder de la determinaciÃ³n',
  'Puedo crear mi camino',
  'Soy fuerte',
  'Mis palabras pueden sanar',
  'Puedo hacer que otros se sientan bien',
  'Soy capaz de amar sin miedo',
  'Tengo el poder de la fe',
  'Puedo encontrar fuerza',
  'Soy digno de ser amado',
  'Mis acciones tienen propÃ³sito',
  'Puedo hacer que la vida sea especial',
  'Soy una persona de valor',
  'Tengo el poder de la pasiÃ³n',
  'Puedo encontrar significado',
  'Soy capaz de amar',
  'Mis elecciones crean mi futuro',
  'Puedo hacer que cada momento cuente',
  'Soy digno de amor incondicional',
  'Tengo el poder de la creatividad',
  'Puedo superar',
  'Soy fuerte',
  'Mis sueÃ±os merecen ser realidad',
  'Puedo hacer que el mundo sea mejor',
  'Soy capaz de amar',
  'Tengo el poder de la perseverancia',
  'Puedo encontrar felicidad',
  'Soy digno de respeto',
  'Mis acciones tienen significado',
  'Puedo crear mi destino',
  'Soy una persona maravillosa',
  'Tengo el poder de la esperanza',
  'Puedo hacer la diferencia',
  'Soy capaz de amar y ser amado',
  'Mis valores me guÃ­an',
  'Puedo encontrar fuerza',
  'Soy digno de Ã©xito',
  'Tengo el poder de la gratitud',
  'Puedo construir mi futuro',
  'Soy capaz',
  'Mis sueÃ±os merecen ser perseguidos',
  'Puedo encontrar belleza',
  'Soy digno de amor',
  'Tengo el poder de la compasiÃ³n',
  'Puedo hacer que otros sonrÃ­an',
  'Soy valioso',
  'Mis acciones tienen impacto',
  'Puedo crear momentos',
  'Soy capaz de amar',
  'Tengo el poder de la resiliencia',
  'Puedo encontrar paz',
  'Soy digno de todo',
  'Mis palabras tienen poder',
  'Puedo hacer que cada dÃ­a cuente',
  'Soy una fuente de luz',
  'Tengo el poder de la autenticidad',
  'Puedo inspirar cambios',
  'Soy fuerte',
  'Mis pensamientos crean mi realidad',
  'Puedo hacer que la vida sea hermosa',
  'Soy capaz de amar profundamente',
  'Tengo el poder de la bondad',
  'Puedo encontrar fuerza',
  'Soy digno de respeto',
  'Mis acciones reflejan mi corazÃ³n',
  'Puedo hacer que otros se sientan especiales',
  'Soy una persona Ãºnica',
  'Tengo el poder de la esperanza',
  'Puedo superar',
  'Soy capaz de amar',
  'Mis sueÃ±os merecen ser perseguidos',
  'Puedo encontrar alegrÃ­a',
  'Soy digno de amor',
  'Tengo el poder de la determinaciÃ³n',
  'Puedo crear mi camino',
  'Soy fuerte',
  'Mis palabras pueden sanar',
  'Puedo hacer que otros se sientan bien',
  'Soy capaz de amar sin miedo',
  'Tengo el poder de la fe',
  'Puedo encontrar fuerza',
  'Soy digno de ser amado',
  'Mis acciones tienen propÃ³sito',
  'Puedo hacer que la vida sea especial',
  'Soy una persona de valor',
  'Tengo el poder de la pasiÃ³n',
  'Puedo encontrar significado',
  'Soy capaz de amar',
  'Mis elecciones crean mi futuro',
  'Puedo hacer que cada momento cuente',
  'Soy digno de amor incondicional',
  'Tengo el poder de la creatividad',
  'Puedo superar',
  'Soy fuerte',
  'Mis sueÃ±os merecen ser realidad',
  'Puedo hacer que el mundo sea mejor',
  'Soy capaz de amar',
  'Tengo el poder de la perseverancia',
  'Puedo encontrar felicidad',
  'Soy digno de respeto',
  'Mis acciones tienen significado',
  'Puedo crear mi destino',
  'Soy una persona maravillosa',
  'Tengo el poder de la esperanza',
  'Puedo hacer la diferencia',
  'Soy capaz de amar y ser amado',
  'Mis valores me guÃ­an',
  'Puedo encontrar fuerza',
  'Soy digno de Ã©xito',
  'Tengo el poder de la gratitud',
  'Puedo construir mi futuro',
  'Soy capaz',
  'Mis sueÃ±os merecen ser perseguidos',
  'Puedo encontrar belleza',
  'Soy digno de amor',
  'Tengo el poder de la compasiÃ³n',
  'Puedo hacer que otros sonrÃ­an',
  'Soy valioso',
  'Mis acciones tienen impacto',
  'Puedo crear momentos',
  'Soy capaz de amar',
  'Tengo el poder de la resiliencia',
  'Puedo encontrar paz',
  'Soy digno de todo',
  'Mis palabras tienen poder',
  'Puedo hacer que cada dÃ­a cuente',
  'Soy una fuente de luz',
  'Tengo el poder de la autenticidad',
  'Puedo inspirar cambios',
  'Soy fuerte',
  'Mis pensamientos crean mi realidad',
  'Puedo hacer que la vida sea hermosa',
  'Soy capaz de amar profundamente',
  'Tengo el poder de la bondad',
  'Puedo encontrar fuerza',
  'Soy digno de respeto',
  'Mis acciones reflejan mi corazÃ³n',
  'Puedo hacer que otros se sientan especiales',
  'Soy una persona Ãºnica',
  'Tengo el poder de la esperanza',
  'Puedo superar',
  'Soy capaz de amar',
  'Mis sueÃ±os merecen ser perseguidos',
  'Puedo encontrar alegrÃ­a',
  'Soy digno de amor',
  'Tengo el poder de la determinaciÃ³n',
  'Puedo crear mi camino',
  'Soy fuerte',
  'Mis palabras pueden sanar',
  'Puedo hacer que otros se sientan bien',
  'Soy capaz de amar sin miedo',
  'Tengo el poder de la fe',
  'Puedo encontrar fuerza',
  'Soy digno de ser amado',
  'Mis acciones tienen propÃ³sito',
  'Puedo hacer que la vida sea especial',
  'Soy una persona de valor',
  'Tengo el poder de la pasiÃ³n',
  'Puedo encontrar significado',
  'Soy capaz de amar',
  'Mis elecciones crean mi futuro',
  'Puedo hacer que cada momento cuente',
  'Soy digno de amor incondicional',
  'Tengo el poder de la creatividad',
  'Puedo superar',
  'Soy fuerte',
  'Mis sueÃ±os merecen ser realidad',
  'Puedo hacer que el mundo sea mejor',
  'Soy capaz de amar',
  'Tengo el poder de la perseverancia',
  'Puedo encontrar felicidad',
  'Soy digno de respeto',
  'Mis acciones tienen significado',
  'Puedo crear mi destino',
  'Soy una persona maravillosa',
  'Tengo el poder de la esperanza',
  'Puedo hacer la diferencia',
  'Soy capaz de amar y ser amado',
  'Mis valores me guÃ­an',
  'Puedo encontrar fuerza',
  'Soy digno de Ã©xito',
  'Tengo el poder de la gratitud',
  'Puedo construir mi futuro',
  'Soy capaz',
  'Mis sueÃ±os merecen ser perseguidos',
  'Puedo encontrar belleza',
  'Soy digno de amor',
  'Tengo el poder de la compasiÃ³n',
  'Puedo hacer que otros sonrÃ­an',
  'Soy valioso',
  'Mis acciones tienen impacto',
  'Puedo crear momentos',
  'Soy capaz de amar',
  'Tengo el poder de la resiliencia',
  'Puedo encontrar paz',
  'Soy digno de todo',
  'Mis palabras tienen poder',
  'Puedo hacer que cada dÃ­a cuente',
  'Soy una fuente de luz',
  'Tengo el poder de la autenticidad',
  'Puedo inspirar cambios',
  'Soy fuerte',
  'Mis pensamientos crean mi realidad',
  'Puedo hacer que la vida sea hermosa',
  'Soy capaz de amar profundamente',
  'Tendo el poder de la bondad',
  'Puedo encontrar fuerza',
  'Soy digno de respeto',
  'Mis acciones reflejan mi corazÃ³n',
  'Puedo hacer que otros se sientan especiales',
  'Soy una persona Ãºnica',
  'Tengo el poder de la esperanza',
  'Puedo superar',
  'Soy capaz de amar',
  'Mis sueÃ±os merecen ser perseguidos',
  'Puedo encontrar alegrÃ­a',
  'Soy digno de amor',
  'Tengo el poder de la determinaciÃ³n',
  'Puedo crear mi camino',
  'Soy fuerte',
  'Mis palabras pueden sanar',
  'Puedo hacer que otros se sientan bien',
  'Soy capaz de amar sin miedo',
  'Tengo el poder de la fe',
  'Puedo encontrar fuerza',
  'Soy digno de ser amado',
  'Mis acciones tienen propÃ³sito',
  'Puedo hacer que la vida sea especial',
  'Soy una persona de valor',
  'Tengo el poder de la pasiÃ³n',
  'Puedo encontrar significado',
  'Soy capaz de amar',
  'Mis elecciones crean mi futuro',
  'Puedo hacer que cada momento cuente',
  'Soy digno de amor incondicional',
  'Tengo el poder de la creatividad',
  'Puedo superar',
  'Soy fuerte',
  'Mis sueÃ±os merecen ser realidad',
  'Puedo hacer que el mundo sea mejor',
  'Soy capaz de amar',
  'Tengo el poder de la perseverancia',
  'Puedo encontrar felicidad',
  'Soy digno de respeto',
  'Mis acciones tienen significado',
  'Puedo crear mi destino',
  'Soy una persona maravillosa',
  'Tengo el poder de la esperanza',
  'Puedo hacer la diferencia',
  'Soy capaz de amar y ser amado',
  'Mis valores me guÃ­an',
  'Puedo encontrar fuerza',
  'Soy digno de Ã©xito',
  'Tengo el poder de la gratitud',
  'Puedo construir mi futuro',
  'Soy capaz',
  'Mis sueÃ±os merecen ser perseguidos',
  'Puedo encontrar belleza',
  'Soy digno de amor',
  'Tengo el poder de la compasiÃ³n',
  'Puedo hacer que otros sonrÃ­an',
  'Soy valioso',
  'Mis acciones tienen impacto',
  'Puedo crear momentos',
  'Soy capaz de amar',
  'Tengo el poder de la resiliencia',
  'Puedo encontrar paz',
  'Soy digno de todo',
  'Mis palabras tienen poder',
  'Puedo hacer que cada dÃ­a cuente',
  'Soy una fuente de luz',
  'Tengo el poder de la autenticidad',
  'Puedo inspirar cambios',
  'Soy fuerte',
  'Mis pensamientos crean mi realidad',
  'Puedo hacer que la vida sea hermosa',
  'Soy capaz de amar profundamente',
  'Tengo el poder de la bondad',
  'Puedo encontrar fuerza',
  'Soy digno de respeto',
  'Mis acciones reflejan mi corazÃ³n',
  'Puedo hacer que otros se sientan especiales',
  'Soy una persona Ãºnica',
  'Tengo el poder de la esperanza',
  'Puedo superar',
  'Soy capaz de amar',
  'Mis sueÃ±os merecen ser perseguidos',
  'Puedo encontrar alegrÃ­a',
  'Soy digno de amor',
  'Tengo el poder de la determinaciÃ³n',
  'Puedo crear mi camino',
  'Soy fuerte',
  'Mis palabras pueden sanar',
  'Puedo hacer que otros se sientan bien',
  'Soy capaz de amar sin miedo',
  'Tengo el poder de la fe',
  'Puedo encontrar fuerza',
  'Soy digno de ser amado',
  'Mis acciones tienen propÃ³sito',
  'Puedo hacer que la vida sea especial',
  'Soy una persona de valor',
  'Tengo el poder de la pasiÃ³n',
  'Puedo encontrar significado',
  'Soy capaz de amar',
  'Mis elecciones crean mi futuro',
  'Puedo hacer que cada momento cuente',
  'Soy digno de amor incondicional',
  'Tengo el poder de la creatividad',
  'Puedo superar',
  'Soy fuerte',
  'Mis sueÃ±os merecen ser realidad',
  'Puedo hacer que el mundo sea mejor',
  'Soy capaz de amar',
  'Tengo el poder de la perseverancia',
  'Puedo encontrar felicidad',
  'Soy digno de respeto',
  'Mis acciones tienen significado',
  'Puedo crear mi destino',
  'Soy una persona maravillosa',
  'Tengo el poder de la esperanza',
  'Puedo hacer la diferencia',
  'Soy capaz de amar y ser amado',
  'Mis valores me guÃ­an',
  'Puedo encontrar fuerza',
  'Soy digno de Ã©xito',
  'Tengo el poder de la gratitud',
  'Puedo construir mi futuro',
  'Soy capaz',
  'Mis sueÃ±os merecen ser perseguidos',
  'Puedo encontrar belleza',
  'Soy digno de amor',
  'Tengo el poder de la compasiÃ³n',
  'Puedo hacer que otros sonrÃ­an',
  'Soy valioso',
  'Mis acciones tienen impacto',
  'Puedo crear momentos',
  'Soy capaz de amar',
  'Tengo el poder de la resiliencia',
  'Puedo encontrar paz',
  'Soy digno de todo',
  'Mis palabras tienen poder',
  'Puedo hacer que cada dÃ­a cuente',
  'Soy una fuente de luz',
  'Tengo el poder de la autenticidad',
  'Puedo inspirar cambios',
  'Soy fuerte',
  'Mis pensamientos crean mi realidad',
  'Puedo hacer que la vida sea hermosa',
  'Soy capaz de amar profundamente',
  'Tengo el poder de la bondad',
  'Puedo encontrar fuerza',
  'Soy digno de respeto',
  'Mis acciones reflejan mi corazÃ³n',
  'Puedo hacer que otros se sientan especiales',
  'Soy una persona Ãºnica',
  'Tengo el poder de la esperanza',
  'Puedo superar',
  'Soy capaz de amar',
  'Mis sueÃ±os merecen ser perseguidos',
  'Puedo encontrar alegrÃ­a',
  'Soy digno de amor',
  'Tengo el poder de la determinaciÃ³n',
  'Puedo crear mi camino',
  'Soy fuerte',
  'Mis palabras pueden sanar',
  'Puedo hacer que otros se sientan bien',
  'Soy capaz de amar sin miedo',
  'Tengo el poder de la fe',
  'Puedo encontrar fuerza',
  'Soy digno de ser amado',
  'Mis acciones tienen propÃ³sito',
  'Puedo hacer que la vida sea especial',
  'Soy una persona de valor',
  'Tengo el poder de la pasiÃ³n',
  'Puedo encontrar significado',
  'Soy capaz de amar',
  'Mis elecciones crean mi futuro',
  'Puedo hacer que cada momento cuente',
  'Soy digno de amor incondicional',
  'Tengo el poder de la creatividad',
  'Puedo superar',
  'Soy fuerte',
  'Mis sueÃ±os merecen ser realidad',
  'Puedo hacer que el mundo sea mejor',
  'Soy capaz de amar',
  'Tengo el poder de la perseverancia',
  'Puedo encontrar felicidad',
  'Soy digno de respeto',
  'Mis acciones tienen significado',
  'Puedo crear mi destino',
  'Soy una persona maravillosa',
  'Tengo el poder de la esperanza',
  'Puedo hacer la diferencia',
  'Soy capaz de amar y ser amado',
  'Mis valores me guÃ­an',
  'Puedo encontrar fuerza',
  'Soy digno de Ã©xito',
  'Tengo el poder de la gratitud',
  'Puedo construir mi futuro',
  'Soy capaz',
  'Mis sueÃ±os merecen ser perseguidos',
  'Puedo encontrar belleza',
  'Soy digno de amor',
  'Tengo el poder de la compasiÃ³n',
  'Puedo hacer que otros sonrÃ­an',
  'Soy valioso',
  'Mis acciones tienen impacto',
  'Puedo crear momentos',
  'Soy capaz de amar',
  'Tengo el poder de la resiliencia',
  'Puedo encontrar paz',
  'Soy digno de todo',
  'Mis palabras tienen poder',
  'Puedo hacer que cada dÃ­a cuente',
  'Soy una fuente de luz',
  'Tengo el poder de la autenticidad',
  'Puedo inspirar cambios',
  'Soy fuerte',
  'Mis pensamientos crean mi realidad',
  'Puedo hacer que la vida sea hermosa',
  'Soy capaz de amar profundamente',
  'Tengo el poder de la bondad',
  'Puedo encontrar fuerza',
  'Soy digno de respeto',
  'Mis acciones reflejan mi corazÃ³n',
  'Puedo hacer que otros se sientan especiales',
  'Soy una persona Ãºnica',
  'Tengo el poder de la esperanza',
  'Puedo superar',
  'Soy capaz de amar',
  'Mis sueÃ±os merecen ser perseguidos',
  'Puedo encontrar alegrÃ­a',
  'Soy digno de amor',
  'Tengo el poder de la determinaciÃ³n',
  'Puedo crear mi camino',
  'Soy fuerte',
  'Mis palabras pueden sanar',
  'Puedo hacer que otros se sientan bien',
  'Soy capaz de amar sin miedo',
  'Tengo el poder de la fe',
  'Puedo encontrar fuerza',
  'Soy digno de ser amado',
  'Mis acciones tienen propÃ³sito',
  'Puedo hacer que la vida sea especial',
  'Soy una persona de valor',
  'Tengo el poder de la pasiÃ³n',
  'Puedo encontrar significado',
  'Soy capaz de amar',
  'Mis elecciones crean mi futuro',
  'Puedo hacer que cada momento cuente',
  'Soy digno de amor incondicional',
  'Tengo el poder de la creatividad',
  'Puedo superar',
  'Soy fuerte',
  'Mis sueÃ±os merecen ser realidad',
  'Puedo hacer que el mundo sea mejor',
  'Soy capaz de amar',
  'Tengo el poder de la perseverancia',
  'Puedo encontrar felicidad',
  'Soy digno de respeto',
  'Mis acciones tienen significado',
  'Puedo crear mi destino',
  'Soy una persona maravillosa',
  'Tengo el poder de la esperanza',
  'Puedo hacer la diferencia',
  'Soy capaz de amar y ser amado',
  'Mis valores me guÃ­an',
  'Puedo encontrar fuerza',
  'Soy digno de Ã©xito',
  'Tono tengo el poder de la gratitud',
  'Puedo construir mi futuro',
  'Soy capaz',
  'Mis sueÃ±os merecen ser perseguidos',
  'Puedo encontrar belleza',
  'Soy digno de amor',
  'Tengo el poder de la compasiÃ³n',
  'Puedo hacer que otros sonrÃ­an',
  'Soy valioso',
  'Mis acciones tienen impacto',
  'Puedo crear momentos',
  'Soy capaz de amar',
  'Tengo el poder de la resiliencia',
  'Puedo encontrar paz',
  'Soy digno de todo',
  'Mis palabras tienen poder',
  'Puedo hacer que cada dÃ­a cuente',
  'Soy una fuente de luz',
  'Tengo el poder de la autenticidad',
  'Puedo inspirar cambios',
  'Soy fuerte',
  'Mis pensamientos crean mi realidad',
  'Puedo hacer que la vida sea hermosa',
  'Soy capaz de amar profundamente',
  'Tengo el poder de la bondad',
  'Puedo encontrar fuerza',
  'Soy digno de respeto',
  'Mis acciones reflejan mi corazÃ³n',
  'Puedo hacer que otros se sientan especiales',
  'Soy una persona Ãºnica',
  'Tengo el poder de la esperanza',
  'Puedo superar',
  'Soy capaz de amar',
  'Mis sueÃ±os merecen ser perseguidos',
  'Puedo encontrar alegrÃ­a',
  'Soy digno de amor',
  'Tengo el poder de la determinaciÃ³n',
  'Puedo crear mi camino',
  'Soy fuerte',
  'Mis palabras pueden sanar',
  'Puedo hacer que otros se sientan bien',
  'Soy capaz de amar sin miedo',
  'Tengo el poder de la fe',
  'Puedo encontrar fuerza',
  'Soy digno de ser amado',
  'Mis acciones tienen propÃ³sito',
  'Puedo hacer que la vida sea especial',
  'Soy una persona de valor',
  'Tengo el poder de la pasiÃ³n',
  'Puedo encontrar significado',
  'Soy capaz de amar',
  'Mis elecciones crean mi futuro',
  'Puedo hacer que cada momento cuente',
  'Soy digno de amor incondicional',
  'Tengo el poder de la creatividad',
  'Puedo superar',
  'Soy fuerte',
  'Mis sueÃ±os merecen ser realidad',
  'Puedo hacer que el mundo sea mejor',
  'Soy capaz de amar',
  'Tono tengo el poder de la gratitud',
  'Puedo construir mi futuro',
  'Soy capaz',
  'Mis sueÃ±os merecen ser perseguidos',
  'Puedo encontrar belleza',
  'Soy digno de amor',
  'Tengo el poder de la compasiÃ³n',
  'Puedo hacer que otros sonrÃ­an',
  'Soy valioso',
  'Mis acciones tienen impacto',
  'Puedo crear momentos',
  'Soy capaz de amar',
  'Tengo el poder de la resiliencia',
  'Puedo encontrar paz',
  'Soy digno de todo',
  'Mis palabras tienen poder',
  'Puedo hacer que cada dÃ­a cuente',
  'Soy una fuente de luz',
  'Tengo el poder de la autenticidad',
  'Puedo inspirar cambios',
  'Soy fuerte',
  'Mis pensamientos crean mi realidad',
  'Puedo hacer que la vida sea hermosa',
  'Soy capaz de amar profundamente',
  'Tengo el poder de la bondad',
  'Puedo encontrar fuerza',
  'Soy digno de respeto',
  'Mis acciones reflejan mi corazÃ³n',
  'Puedo hacer que otros se sientan especiales',
  'Soy una persona Ãºnica',
  'Tengo el poder de la esperanza',
  'Puedo superar',
  'Soy capaz de amar',
  'Mis sueÃ±os merecen ser perseguidos',
  'Puedo encontrar alegrÃ­a',
  'Soy digno de amor',
  'Tengo el poder de la determinaciÃ³n',
  'Puedo crear mi camino',
  'Soy fuerte',
  'Mis palabras pueden sanar',
  'Puedo hacer que otros se sientan bien',
  'Soy capaz de amar sin miedo',
  'Tengo el poder de la fe',
  'Puedo encontrar fuerza',
  'Soy digno de ser amado',
  'Mis acciones tienen propÃ³sito',
  'Puedo hacer que la vida sea especial',
  'Soy una persona de valor',
  'Tengo el poder de la pasiÃ³n',
  'Puedo encontrar significado',
  'Soy capaz de amar',
  'Mis elecciones crean mi futuro',
  'Puedo hacer que cada momento cuente',
  'Soy digno de amor incondicional',
  'Tengo el poder de la creatividad',
  'Puedo superar',
  'Soy fuerte',
  'Mis sueÃ±os merecen ser realidad',
  'Puedo hacer que el mundo sea mejor',
  'Soy capaz de amar',
  'Tengo el poder de la perseverancia',
  'Puedo encontrar felicidad',
  'Soy digno de respeto',
  'Mis acciones tienen significado',
  'Puedo crear mi destino',
  'Soy una persona maravillosa',
  'Tendo el poder de la esperanza',
  'Puedo hacer la diferencia',
  'Soy capaz de amar y ser amado',
  'Mis valores me guÃ­an',
  'Puedo encontrar fuerza',
  'Soy digno de Ã©xito',
  'Tengo el poder de la gratitud',
  'Puedo construir mi futuro',
  'Soy capaz',
  'Mis sueÃ±os merecen ser perseguidos',
  'Puedo encontrar belleza',
  'Soy digno de amor',
  'Tengo el poder de la compasiÃ³n',
  'Puedo hacer que otros sonrÃ­an',
  'Soy valioso',
  'Mis acciones tienen impacto',
  'Puedo crear momentos',
  'Soy capaz de amar',
  'Tengo el poder de la resiliencia',
  'Puedo encontrar paz',
  'Soy digno de todo',
  'Mis palabras tienen poder',
  'Puedo hacer que cada dÃ­a cuente',
  'Soy una fuente de luz',
  'Tengo el poder de la autenticidad',
  'Puedo inspirar cambios',
  'Soy fuerte',
  'Mis pensamientos crean mi realidad',
  'Puedo hacer que la vida sea hermosa',
  'Soy capaz de amar profundamente',
  'Tengo el poder de la bondad',
  'Puedo encontrar fuerza',
  'Soy digno de respeto',
  'Mis acciones reflejan mi corazÃ³n',
  'Puedo hacer que otros se sientan especiales',
  'Soy una persona Ãºnica',
  'Tengo el poder de la esperanza',
  'Puedo superar',
  'Soy capaz de amar',
  'Mis sueÃ±os merecen ser perseguidos',
  'Puedo encontrar alegrÃ­a',
  'Soy digno de amor',
  'Tengo el poder de la determinaciÃ³n',
  'Puedo crear mi camino',
  'Soy fuerte',
  'Mis palabras pueden sanar',
  'Puedo hacer que otros se sientan bien',
  'Soy capaz de amar sin miedo',
  'Tengo el poder de la fe',
  'Puedo encontrar fuerza',
  'Soy digno de ser amado',
  'Mis acciones tienen propÃ³sito',
  'Puedo hacer que la vida sea especial',
  'Soy una persona de valor',
  'Tengo el poder de la pasiÃ³n',
  'Puedo encontrar significado',
  'Soy capaz de amar',
  'Mis elecciones crean mi futuro',
  'Puedo hacer que cada momento cuente',
  'Soy digno de amor incondicional',
  'Tengo el poder de la creatividad',
  'Puedo superar',
  'Soy fuerte',
  'Mis sueÃ±os merecen ser realidad',
  'Puedo hacer que el mundo sea mejor',
  'Soy capaz de amar',
  'Tengo el poder de la perseverancia',
  'Puedo encontrar felicidad',
  'Soy digno de respeto',
  'Mis acciones tienen significado',
  'Puedo crear mi destino',
  'Soy una persona maravillosa',
  'Tengo el poder de la esperanza',
  'Puedo hacer la diferencia',
  'Soy capaz de amar y ser amado',
  'Mis valores me guÃ­an',
  'Puedo encontrar fuerza',
  'Soy digno de Ã©xito',
  'Tengo el poder de la gratitud',
  'Puedo construir mi futuro',
  'Soy capaz',
  'Mis sueÃ±os merecen ser perseguidos',
  'Puedo encontrar belleza',
  'Soy digno de amor',
  'Tengo el poder de la compasiÃ³n',
  'Puedo hacer que otros sonrÃ­an',
  'Soy valioso',
  'Mis acciones tienen impacto',
  'Puedo crear momentos',
  'Soy capaz de amar',
  'Tengo el poder de la resiliencia',
  'Puedo encontrar paz',
  'Soy digno de todo',
  'Mis palabras tienen poder',
  'Puedo hacer que cada dÃ­a cuente',
  'Soy una fuente de luz',
  'Tengo el poder de la autenticidad',
  'Puedo inspirar cambios',
  'Soy fuerte',
  'Mis pensamientos crean mi realidad',
  'Puedo hacer que la vida sea hermosa',
  'Soy capaz de amar profundamente',
  'Tendo el poder de la bondad',
  'Puedo encontrar fuerza',
  'Soy digno de respeto',
  'Mis acciones reflejan mi corazÃ³n',
  'Puedo hacer que otros se sientan especiales',
  'Soy una persona Ãºnica',
  'Tengo el poder de la esperanza',
  'Puedo superar',
  'Soy capaz de amar',
  'Mis sueÃ±os merecen ser perseguidos',
  'Puedo encontrar alegrÃ­a',
  'Soy digno de amor',
  'Tengo el poder de la determinaciÃ³n',
  'Puedo crear mi camino',
  'Soy fuerte',
  'Mis palabras pueden sanar',
  'Puedo hacer que otros se sientan bien',
  'Soy capaz de amar sin miedo',
  'Tengo el poder de la fe',
  'Puedo encontrar fuerza',
  'Soy digno de ser amado',
  'Mis acciones tienen propÃ³sito',
  'Puedo hacer que la vida sea especial',
  'Soy una persona de valor',
  'Tengo el poder de la pasiÃ³n',
  'Puedo encontrar significado',
  'Soy capaz de amar',
  'Mis elecciones crean mi futuro',
  'Puedo hacer que cada momento cuente',
  'Soy digno de amor incondicional',
  'Tengo el poder de la creatividad',
  'Puedo superar',
  'Soy fuerte',
  'Mis sueÃ±os merecen ser realidad',
  'Puedo hacer que el mundo sea mejor',
  'Soy capaz de amar',
  'Tengo el poder de la perseverancia',
  'Puedo encontrar felicidad',
  'Soy digno de respeto',
  'Mis acciones tienen significado',
  'Puedo crear mi destino',
  'Soy una persona maravillosa',
  'Tengo el poder de la esperanza',
  'Puedo hacer la diferencia',
  'Soy capaz de amar y ser amado',
  'Mis valores me guÃ­an',
  'Puedo encontrar fuerza',
  'Soy digno de Ã©xito',
  'Tono tengo el poder de la gratitud',
  'Puedo construir mi futuro',
  'Soy capaz',
  'Mis sueÃ±os merecen ser perseguidos',
  'Puedo encontrar belleza',
  'Soy digno de amor',
  'Tengo el poder de la compasiÃ³n',
  'Puedo hacer que otros sonrÃ­an',
  'Soy valioso',
  'Mis acciones tienen impacto',
  'Puedo crear momentos',
  'Soy capaz de amar',
  'Tengo el poder de la resiliencia',
  'Puedo encontrar paz',
  'Soy digno de todo',
  'Mis palabras tienen poder',
  'Puedo hacer que cada dÃ­a cuente',
  'Soy una fuente de luz',
  'Tengo el poder de la autenticidad',
  'Puedo inspirar cambios',
  'Soy fuerte',
  'Mis pensamientos crean mi realidad',
  'Puedo hacer que la vida sea hermosa',
  'Soy capaz de amar profundamente',
  'Tengo el poder de la bondad',
  'Puedo encontrar fuerza',
  'Soy digno de respeto',
  'Mis acciones reflejan mi corazÃ³n',
  'Puedo hacer que otros se sientan especiales',
  'Soy una persona Ãºnica',
  'Tengo el poder de la esperanza',
  'Puedo superar',
  'Soy capaz de amar',
  'Mis sueÃ±os merecen ser perseguidos',
  'Puedo encontrar alegrÃ­a',
  'Soy digno de amor',
  'Tendo el poder de la determinaciÃ³n',
  'Puedo crear mi camino',
  'Soy fuerte',
  'Mis palabras pueden sanar',
  'Puedo hacer que otros se sientan bien',
  'Soy capaz de amar sin miedo',
  'Tengo el poder de la fe',
  'Puedo encontrar fuerza',
  'Soy digno de ser amado',
  'Mis acciones tienen propÃ³sito',
  'Puedo hacer que la vida sea especial',
  'Soy una persona de valor',
  'Tengo el poder de la pasiÃ³n',
  'Puedo encontrar significado',
  'Soy capaz de amar',
  'Mis elecciones crean mi futuro',
  'Puedo hacer que cada momento cuente',
  'Soy digno de amor incondicional',
  'Tengo el poder de la creatividad',
  'Puedo superar',
  'Soy fuerte',
  'Mis sueÃ±os merecen ser realidad',
  'Puedo hacer que el mundo sea mejor',
  'Soy capaz de amar',
  'Tengo el poder de la perseverancia',
  'Puedo encontrar felicidad',
  'Soy digno de respeto',
  'Mis acciones tienen significado',
  'Puedo crear mi destino',
  'Soy una persona maravillosa',
  'Tengo el poder de la esperanza',
  'Puedo hacer la diferencia',
  'Soy capaz de amar y ser amado',
  'Mis valores me guÃ­an',
  'Puedo encontrar fuerza',
  'Soy digno de Ã©xito',
  'Tengo el poder de la gratitud',
  'Puedo construir mi futuro',
  'Soy capaz',
  'Mis sueÃ±os merecen ser perseguidos',
  'Puedo encontrar belleza',
  'Soy digno de amor',
  'Tengo el poder de la compasiÃ³n',
  'Puedo hacer que otros sonrÃ­an',
  'Soy valioso',
  'Mis acciones tienen impacto',
  'Puedo crear momentos',
  'Soy capaz de amar',
  'Tengo el poder de la resiliencia',
  'Puedo encontrar paz',
  'Soy digno de todo',
  'Mis palabras tienen poder',
  'Puedo hacer que cada dÃ­a cuente',
  'Soy una fuente de luz',
  'Tengo el poder de la autenticidad',
  'Puedo inspirar cambios',
  'Soy fuerte',
  'Mis pensamientos crean mi realidad',
  'Puedo hacer que la vida sea hermosa',
  'Soy capaz de amar profundamente',
  'Tengo el poder de la bondad',
  'Puedo encontrar fuerza',
  'Soy digno de respeto',
  'Mis acciones reflejan mi corazÃ³n',
  'Puedo hacer que otros se sientan especiales',
  'Soy una persona Ãºnica',
  'Tengo el poder de la esperanza',
  'Puedo superar',
  'Soy capaz de amar',
  'Mis sueÃ±os merecen ser perseguidos',
  'Puedo encontrar alegrÃ­a',
  'Soy digno de amor',
  'Tengo el poder de la determinaciÃ³n',
  'Puedo crear mi camino',
  'Soy fuerte',
  'Mis palabras pueden sanar',
  'Puedo hacer que otros se sientan bien',
  'Soy capaz de amar sin miedo',
  'Tengo el poder de la fe',
  'Puedo encontrar fuerza',
  'Soy digno de ser amado',
  'Mis acciones tienen propÃ³sito',
  'Puedo hacer que la vida sea especial',
  'Soy una persona de valor',
  'Tengo el poder de la pasión',
  'Puedo encontrar significado',
  'Soy capaz de amar',
  'Mis elecciones crean mi futuro',
  'Puedo hacer que cada momento cuente',
  'Soy digno de amor incondicional',
  'Tengo el poder de la creatividad',
  'Puedo superar',
  'Soy fuerte',
  'Mis sueÃ±os merecen ser realidad',
  'Puedo hacer que el mundo sea mejor',
  'Soy capaz de amar',
  'Tengo el poder de la perseverancia',
  'Puedo encontrar felicidad',
  'Soy digno de respeto',
  'Mis acciones tienen significado',
  'Puedo crear mi destino',
  'Soy una persona maravillosa',
  'Tengo el poder de la esperanza',
  'Puedo hacer la diferencia',
  'Soy capaz de amar y ser amado',
  'Mis valores me guÃ­an',
  'Puedo encontrar fuerza',
  'Soy digno de Ã©xito',
  'Tengo el poder de la gratitud',
  'Puedo construir mi futuro',
  'Soy capaz',
  'Mis sueÃ±os merecen ser perseguidos',
  'Puedo encontrar belleza',
  'Soy digno de amor',
  'Tengo el poder de la compasiÃ³n',
  'Puedo hacer que otros sonrÃ­an',
  'Soy valioso',
  'Mis acciones tienen impacto',
  'Puedo crear momentos',
  'Soy capaz de amar',
  'Tengo el poder de la resiliencia',
  'Puedo encontrar paz',
  'Soy digno de todo',
  'Mis palabras tienen poder',
  'Puedo hacer que cada dÃ­a cuente',
  'Soy una fuente de luz',
  'Tengo el poder de la autenticidad',
  'Puedo inspirar cambios',
  'Soy fuerte',
  'Mis pensamientos crean mi realidad',
  'Puedo hacer que la vida sea hermosa',
  'Soy capaz de amar profundamente',
  'Tengo el poder de la bondad',
  'Puedo encontrar fuerza',
  'Soy digno de respeto',
  'Mis acciones reflejan mi corazÃ³n',
  'Puedo hacer que otros se sientan especiales',
  'Soy una persona Ãºnica',
  'Tengo el poder de la esperanza',
  'Puedo superar',
  'Soy capaz de amar',
  'Mis sueÃ±os merecen ser perseguidos',
  'Puedo encontrar alegrÃ­a',
  'Soy digno de amor',
  'Tengo el poder de la determinaciÃ³n',
  'Puedo crear mi camino',
  'Soy fuerte',
  'Mis palabras pueden sanar',
  'Puedo hacer que otros se sientan bien',
  'Soy capaz de amar sin miedo',
  'Tengo el poder de la fe',
  'Puedo encontrar fuerza',
  'Soy digno de ser amado',
  'Mis acciones tienen propÃ³sito',
  'Puedo hacer que la vida sea especial',
  'Soy una persona de valor',
  'Tengo el poder de la pasiÃ³n',
  'Puedo encontrar significado',
  'Soy capaz de amar',
  'Mis elecciones crean mi futuro',
  'Puedo hacer que cada momento cuente',
  'Soy digno de amor incondicional',
  'Tengo el poder de la creatividad',
  'Puedo superar',
  'Soy fuerte',
  'Mis sueÃ±os merecen ser realidad',
  'Puedo hacer que el mundo sea mejor',
  'Soy capaz de amar',
  'Tengo el poder de la perseverancia',
  'Puedo encontrar felicidad',
  'Soy digno de respeto',
  'Mis acciones tienen significado',
  'Puedo crear mi destino',
  'Soy una persona maravillosa',
  'Tengo el poder de la esperanza',
  'Puedo hacer la diferencia',
  'Soy capaz de amar y ser amado',
  'Mis valores me guÃ­an',
  'Puedo encontrar fuerza',
  'Soy digno de Ã©xito',
  'Tengo el poder de la gratitud',
  'Puedo construir mi futuro',
  'Soy capaz',
  'Mis sueÃ±os merecen ser perseguidos',
  'Puedo encontrar belleza',
  'Soy digno de amor',
  'Tengo el poder de la compasiÃ³n',
  'Puedo hacer que otros sonrÃ­an',
  'Soy valioso',
  'Mis acciones tienen impacto',
  'Puedo crear momentos',
  'Soy capaz de amar',
  'Tengo el poder de la resiliencia',
  'Puedo encontrar paz',
  'Soy digno de todo',
  'Mis palabras tienen poder',
  'Puedo hacer que cada dÃ­a cuente',
  'Soy una fuente de luz',
  'Tengo el poder de la autenticidad',
  'Puedo inspirar cambios',
  'Soy fuerte',
  'Mis pensamientos crean mi realidad',
  'Puedo hacer que la vida sea hermosa',
  'Soy capaz de amar profundamente',
  'Tengo el poder de la bondad',
  'Puedo encontrar fuerza',
  'Soy digno de respeto',
  'Mis acciones reflejan mi corazÃ³n',
  'Puedo hacer que otros se sientan especiales',
  'Soy una persona Ãºnica',
  'Tengo el poder de la esperanza',
  'Puedo superar',
  'Soy capaz de amar',
  'Mis sueÃ±os merecen ser perseguidos',
  'Puedo encontrar alegrÃ­a',
  'Soy digno de amor',
  'Tengo el poder de la determinaciÃ³n',
  'Puedo crear mi camino',
  'Soy fuerte',
  'Mis palabras pueden sanar',
  'Puedo hacer que otros se sientan bien',
  'Soy capaz de amar sin miedo',
  'Tengo el poder de la fe',
  'Puedo encontrar fuerza',
  'Soy digno de ser amado',
  'Mis acciones tienen propÃ³sito',
  'Puedo hacer que la vida sea especial',
  'Soy una persona de valor',
  'Tengo el poder de la pasiÃ³n',
  'Puedo encontrar significado',
  'Soy capaz de amar',
  'Mis elecciones crean mi futuro',
  'Puedo hacer que cada momento cuente',
  'Soy digno de amor incondicional',
  'Tengo el poder de la creatividad',
  'Puedo superar',
  'Soy fuerte',
  'Mis sueÃ±os merecen ser realidad',
  'Puedo hacer que el mundo sea mejor',
  'Soy capaz de amar',
  'Tengo el poder de la perseverancia',
  'Puedo encontrar felicidad',
  'Soy digno de respeto',
  'Mis acciones tienen significado',
  'Puedo crear mi destino',
  'Soy una persona maravillosa',
  'Tengo el poder de la esperanza',
  'Puedo hacer la diferencia',
  'Soy capaz de amar y ser amado',
  'Mis valores me guÃ­an',
  'Puedo encontrar fuerza',
  'Soy digno de Ã©xito',
  'Tengo el poder de la gratitud',
  'Puedo construir mi futuro',
  'Soy capaz',
  'Mis sueÃ±os merecen ser perseguidos',
  'Puedo encontrar belleza',
  'Soy digno de amor',
  'Tengo el poder de la compasiÃ³n',
  'Puedo hacer que otros sonrÃ­an',
  'Soy valioso',
  'Mis acciones tienen impacto',
  'Puedo crear momentos',
  'Soy capaz de amar',
  'Tengo el poder de la resiliencia',
  'Puedo encontrar paz',
  'Soy digno de todo',
  'Mis palabras tienen poder',
  'Puedo hacer que cada dÃ­a cuente',
  'Soy una fuente de luz',
  'Tengo el poder de la autenticidad',
  'Puedo inspirar cambios',
  'Soy fuerte',
  'Mis pensamientos crean mi realidad',
  'Puedo hacer que la vida sea hermosa',
  'Soy capaz de amar profundamente',
  'Tengo el poder de la bondad',
  'Puedo encontrar fuerza',
  'Soy digno de respeto',
  'Mis acciones reflejan mi corazÃ³n',
  'Puedo hacer que otros se sientan especiales',
  'Song una persona Ãºnica',
  'Tengo el poder de la esperanza',
  'Puedo superar',
  'Soy capaz de amar',
  'Mis sueÃ±os merecen ser perseguidos',
  'Puedo encontrar alegrÃ­a',
  'Soy digno de amor',
  'Tengo el poder de la determinaciÃ³n',
  'Puedo crear mi camino',
  'Soy fuerte',
  'Mis palabras pueden sanar',
  'Puedo hacer que otros se sientan bien',
  'Soy capaz de amar sin miedo',
  'Tengo el poder de la fe',
  'Puedo encontrar fuerza',
  'Soy digno de ser amado',
  'Mis acciones tienen propÃ³sito',
  'Puedo hacer que la vida sea especial',
  'Soy una persona de valor',
  'Tengo el poder de la pasiÃ³n',
  'Puedo encontrar significado',
  'Soy capaz de amar',
  'Mis elecciones crean mi futuro',
  'Puedo hacer que cada momento cuente',
  'Soy digno de amor incondicional',
  'Tengo el poder de la creatividad',
  'Puedo superar',
  'Soy fuerte',
  'Mis sueÃ±os merecen ser realidad',
  'Puedo hacer que el mundo sea mejor',
  'Soy capaz de amar',
  'Tengo el poder de la perseverancia',
  'Puedo encontrar felicidad',
  'Soy digno de respeto',
  'Mis acciones tienen significado',
  'Puedo crear mi destino',
  'Soy una persona maravillosa',
  'Tengo el poder de la esperanza',
  'Puedo hacer la diferencia',
  'Soy capaz de amar y ser amado',
  'Mis valores me guÃ­an',
  'Puedo encontrar fuerza',
  'Soy digno de Ã©xito',
  'Tengo el poder de la gratitud',
  'Puedo construir mi futuro',
  'Soy capaz',
  'Mis sueÃ±os merecen ser perseguidos',
  'Puedo encontrar belleza',
  'Soy digno de amor',
  'Tengo el poder de la compasiÃ³n',
  'Puedo hacer que otros sonrÃ­an',
  'Soy valioso',
  'Mis acciones tienen impacto',
  'Puedo crear momentos',
  'Soy capaz de amar',
  'Tengo el poder de la resiliencia',
  'Puedo encontrar paz',
  'Soy digno de todo',
  'Mis palabras tienen poder',
  'Puedo hacer que cada dÃ­a cuente',
  'Soy una fuente de luz',
  'Tengo el poder de la autenticidad',
  'Puedo inspirar cambios',
  'Soy fuerte',
  'Mis pensamientos crean mi realidad',
  'Puedo hacer que la vida sea hermosa',
  'Soy capaz de amar profundamente',
  'Tengo el poder de la bondad',
  'Puedo encontrar fuerza',
  'Soy digno de respeto',
  'Mis acciones reflejan mi corazÃ³n',
  'Puedo hacer que otros se sientan especiales',
  'Soy una persona Ãºnica',
  'Tengo el poder de la esperanza',
  'Puedo superar',
  'Soy capaz de amar',
  'Mis sueÃ±os merecen ser perseguidos',
  'Puedo encontrar alegrÃ­a',
  'Soy digno de amor',
  'Tengo el poder de la determinaciÃ³n',
  'Puedo crear mi camino',
  'Soy fuerte',
  'Mis palabras pueden sanar',
  'Puedo hacer que otros se sientan bien',
  'Soy capaz de amar sin miedo',
  'Tengo el poder de la fe',
  'Puedo encontrar fuerza',
  'Soy digno de ser amado',
  'Mis acciones tienen propÃ³sito',
  'Puedo hacer que la vida sea especial',
  'Soy una persona de valor',
  'Tengo el poder de la pasiÃ³n',
  'Puedo encontrar significado',
  'Soy capaz de amar',
  'Mis elecciones crean mi futuro',
  'Puedo hacer que cada momento cuente',
  'Soy digno de amor incondicional',
  'Tengo el poder de la creatividad',
  'Puedo superar',
  'Soy fuerte',
  'Mis sueÃ±os merecen ser realidad',
  'Puedo hacer que el mundo sea mejor',
  'Soy capaz de amar',
  'Tongo el poder de la perseverancia',
  'Puedo encontrar felicidad',
  'Soy digno de respeto',
  'Mis acciones tienen significado',
  'Puedo crear mi destino',
  'Soy una persona maravillosa',
  'Tengo el poder de la esperanza',
  'Puedo hacer la diferencia',
  'Soy capaz de amar y ser amado',
  'Mis valores me guÃ­an',
  'Puedo encontrar fuerza',
  'Soy digno de Ã©xito',
  'Tengo el poder de la gratitud',
  'Puedo construir mi futuro',
  'Soy capaz',
  'Mis sueÃ±os merecen ser perseguidos',
  'Puedo encontrar belleza',
  'Soy digno de amor',
  'Tengo el poder de la compasiÃ³n',
  'Puedo hacer que otros sonrÃ­an',
  'Soy valioso',
  'Mis acciones tienen impacto',
  'Puedo crear momentos',
  'Soy capaz de amar',
  'Tengo el poder de la resiliencia',
  'Puedo encontrar paz',
  'Soy digno de todo',
  'Mis palabras tienen poder',
  'Puedo hacer que cada dÃ­a cuente',
  'Soy una fuente de luz',
  'Tengo el poder de la autenticidad',
  'Puedo inspirar cambios',
  'Song fuerte',
  'Mis pensamientos crean mi realidad',
  'Puedo hacer que la vida sea hermosa',
  'Soy capaz de amar profundamente',
  'Tengo el poder de la bondad',
  'Puedo encontrar fuerza',
  'Soy digno de respeto',
  'Mis acciones reflejan mi corazÃ³n',
  'Puedo hacer que otros se sientan especiales',
  'Soy una persona Ãºnica',
  'Tengo el poder de la esperanza',
  'Puedo superar',
  'Soy capaz de amar',
  'Mis sueÃ±os merecen ser perseguidos',
  'Puedo encontrar alegrÃ­a',
  'Soy digno de amor',
  'Tengo el poder de la determinaciÃ³n',
  'Puedo crear mi camino',
  'Soy fuerte',
  'Mis palabras pueden sanar',
  'Puedo hacer que otros se sientan bien',
  'Soy capaz de amar sin miedo',
  'Tengo el poder de la fe',
  'Puedo encontrar fuerza',
  'Soy digno de ser amado',
  'Mis acciones tienen propÃ³sito',
  'Puedo hacer que la vida sea especial',
  'Soy una persona de valor',
  'Tengo el poder de la pasiÃ³n',
  'Puedo encontrar significado',
  'Soy capaz de amar',
  'Mis elecciones crean mi futuro',
  'Puedo hacer que cada momento cuente',
  'Soy digno de amor incondicional',
  'Tengo el poder de la creatividad',
  'Puedo superar',
  'Soy fuerte',
  'Mis sueÃ±os merecen ser realidad',
  'Puedo hacer que el mundo sea mejor',
  'Soy capaz de amar',
  'Tengo el poder de la perseverancia',
  'Puedo encontrar felicidad',
  'Soy digno de respeto',
  'Mis acciones tienen significado',
  'Puedo crear mi destino',
  'Soy una persona maravillosa',
  'Tengo el poder de la esperanza',
  'Puedo hacer la diferencia',
  'Soy capaz de amar y ser amado',
  'Mis valores me guÃ­an',
  'Puedo encontrar fuerza',
  'Soy digno de Ã©xito',
  'Tengo el poder de la gratitud',
  'Puedo construir mi futuro',
  'Soy capaz',
  'Mis sueÃ±os merecen ser perseguidos',
  'Puedo encontrar belleza',
  'Soy digno de amor',
  'Tengo el poder de la compasiÃ³n',
  'Puedo hacer que otros sonrÃ­an',
  'Soy valioso',
  'Mis acciones tienen impacto',
  'Puedo crear momentos',
  'Soy capaz de amar',
  'Tengo el poder de la resiliencia',
  'Puedo encontrar paz',
  'Soy digno de todo',
  'Mis palabras tienen poder',
  'Puedo hacer que cada dÃ­a cuente',
  'Soy una fuente de luz',
  'Tengo el poder de la autenticidad',
  'Puedo inspirar cambios',
  'Soy fuerte',
  'Mis pensamientos crean mi realidad',
  'Puedo hacer que la vida sea hermosa',
  'Soy capaz de amar profundamente',
  'Tengo el poder de la bondad',
  'Puedo encontrar fuerza',
  'Soy digno de respeto',
  'Mis acciones reflejan mi corazÃ³n',
  'Puedo hacer que otros se sientan especiales',
  'Soy una persona Ãºnica',
  'Tengo el poder de la esperanza',
  'Puedo superar',
  'Soy capaz de amar',
  'Mis sueÃ±os merecen ser perseguidos',
  'Puedo encontrar alegrÃ­a',
  'Soy digno de amor',
  'Tengo el poder de la determinaciÃ³n',
  'Puedo crear mi camino',
  'Soy fuerte',
  'Mis palabras pueden sanar',
  'Puedo hacer que otros se sientan bien',
  'Soy capaz de amar sin miedo',
  'Tengo el poder de la fe',
  'Puedo encontrar fuerza',
  'Soy digno de ser amado',
  'Mis acciones tienen propÃ³sito',
  'Puedo hacer que la vida sea especial',
  'Soy una persona de valor',
  'Tengo el poder de la pasiÃ³n',
  'Puedo encontrar significado',
  'Soy capaz de amar',
  'Mis elecciones crean mi futuro',
  'Puedo hacer que cada momento cuente',
  'Soy digno de amor incondicional',
  'Tengo el poder de la creatividad',
  'Puedo superar',
  'Soy fuerte',
  'Mis sueÃ±os merecen ser realidad',
  'Puedo hacer que el mundo sea mejor',
  'Soy capaz de amar',
  'Tengo el poder de la perseverancia',
  'Puedo encontrar felicidad',
  'Soy digno de respeto',
  'Mis acciones tienen significado',
  'Puedo crear mi destino',
  'Soy una persona maravillosa',
  'Tengo el poder de la esperanza',
  'Puedo hacer la diferencia',
  'Soy capaz de amar y ser amado',
  'Mis valores me guÃ­an',
  'Puedo encontrar fuerza',
  'Soy digno de Ã©xito',
  'Tengo el poder de la gratitud',
  'Puedo construir mi futuro',
  'Soy capaz',
  'Mis sueÃ±os merecen ser perseguidos',
  'Puedo encontrar belleza',
  'Soy digno de amor',
  'Tengo el poder de la compasiÃ³n',
  'Puedo hacer que otros sonrÃ­an',
  'Soy valioso',
  'Mis acciones tienen impacto',
  'Puedo crear momentos',
  'Soy capaz de amar',
  'Tengo el poder de la resiliencia',
  'Puedo encontrar paz',
  'Soy digno de todo',
  'Mis palabras tienen poder',
  'Puedo hacer que cada dÃ­a cuente',
  'Soy una fuente de luz',
  'Tengo el poder de la autenticidad',
  'Puedo inspirar cambios',
  'Soy fuerte',
  'Mis pensamientos crean mi realidad',
  'Puedo hacer que la vida sea hermosa',
  'Soy capaz de amar profundamente',
  'Tengo el poder de la bondad',
  'Puedo encontrar fuerza',
  'Soy digno de respeto',
  'Mis acciones reflejan mi corazÃ³n',
  'Puedo hacer que otros se sientan especiales',
  'Soy una persona Ãºnica',
  'Tengo el poder de la esperanza',
  'Puedo superar',
  'Soy capaz de amar',
  'Mis sueÃ±os merecen ser perseguidos',
  'Puedo encontrar alegrÃ­a',
  'Soy digno de amor',
  'Tengo el poder de la determinaciÃ³n',
  'Puedo crear mi camino',
  'Soy fuerte',
  'Mis palabras pueden sanar',
  'Puedo hacer que otros se sientan bien',
  'Soy capaz de amar sin miedo',
  'Tengo el poder de la fe',
  'Puedo encontrar fuerza',
  'Soy digno de ser amado',
  'Mis acciones tienen propÃ³sito',
  'Puedo hacer que la vida sea especial',
  'Soy una persona de valor',
  'Tengo el poder de la pasiÃ³n',
  'Puedo encontrar significado',
  'Soy capaz de amar',
  'Mis elecciones crean mi futuro',
  'Puedo hacer que cada momento cuente',
  'Soy digno de amor incondicional',
  'Tengo el poder de la creatividad',
  'Puedo superar',
  'Soy fuerte',
  'Mis sueÃ±os merecen ser realidad',
  'Puedo hacer que el mundo sea mejor',
  'Soy capaz de amar',
  'Tengo el poder de la perseverancia',
  'Puedo encontrar felicidad',
  'Soy digno de respeto',
  'Mis acciones tienen significado',
  'Puedo crear mi destino',
  'Soy una persona maravillosa',
  'Tengo el poder de la esperanza',
  'Puedo hacer la diferencia',
  'Soy capaz de amar y ser amado',
  'Mis valores me guÃ­an',
  'Puedo encontrar fuerza',
  'Soy digno de Ã©xito',
  'Tengo el poder de la gratitud',
  'Puedo construir mi futuro',
  'Soy capaz',
  'Mis sueÃ±os merecen ser perseguidos',
  'Puedo encontrar belleza',
  'Soy digno de amor',
  'Tengo el poder de la compasiÃ³n',
  'Puedo hacer que otros sonrÃ­an',
  'Soy valioso',
  'Mis acciones tienen impacto',
  'Puedo crear momentos',
  'Soy capaz de amar',
  'Tengo el poder de la resiliencia',
  'Puedo encontrar paz',
  'Soy digno de todo',
  'Mis palabras tienen poder',
  'Puedo hacer que cada dÃ­a cuente',
  'Soy una fuente de luz',
  'Tengo el poder de la autenticidad',
  'Puedo inspirar cambios',
  'Soy fuerte',
  'Mis pensamientos crean mi realidad',
  'Puedo hacer que la vida sea hermosa',
  'Soy capaz de amar profundamente',
  'Tengo el poder de la bondad',
  'Puedo encontrar fuerza',
  'Soy digno de respeto',
  'Mis acciones reflejan mi corazÃ³n',
  'Puedo hacer que otros se sientan especiales',
  'Soy una persona Ãºnica',
  'Tengo el poder de la esperanza',
  'Puedo superar',
  'Soy capaz de amar',
  'Mis sueÃ±os merecen ser perseguidos',
  'Puedo encontrar alegrÃ­a',
  'Soy digno de amor',
  'Tengo el poder de la determinaciÃ³n',
  'Puedo crear mi camino',
  'Soy fuerte',
  'Mis palabras pueden sanar',
  'Puedo hacer que otros se sientan bien',
  'Soy capaz de amar sin miedo',
  'Tengo el poder de la fe',
  'Puedo encontrar fuerza',
  'Soy digno de ser amado',
  'Mis acciones tienen propÃ³sito',
  'Puedo hacer que la vida sea especial',
  'Soy una persona de valor',
  'Tengo el poder de la pasiÃ³n',
  'Puedo encontrar significado',
  'Soy capaz de amar',
  'Mis elecciones crean mi futuro',
  'Puedo hacer que cada momento cuente',
  'Soy digno de amor incondicional',
  'Tengo el poder de la creatividad',
  'Puedo superar',
  'Soy fuerte',
  'Mis sueÃ±os merecen ser realidad',
  'Puedo hacer que el mundo sea mejor',
  'Soy capaz de amar',
  'Tengo el poder de la perseverancia',
  'Puedo encontrar felicidad',
  'Soy digno de respeto',
  'Mis acciones tienen significado',
  'Puedo crear mi destino',
  'Soy una persona maravillosa',
  'Tengo el poder de la esperanza',
  'Puedo hacer la diferencia',
  'Soy capaz de amar y ser amado',
  'Mis valores me guÃ­an',
  'Puedo encontrar fuerza',
  'Soy digno de Ã©xito',
  'Tengo el poder de la gratitud',
  'Puedo construir mi futuro',
  'Soy capaz',
  'Mis sueÃ±os merecen ser perseguidos',
  'Puedo encontrar belleza',
  'Soy digno de amor',
  'Tengo el poder de la compasiÃ³n',
  'Puedo hacer que otros sonrÃ­an',
  'Soy valioso',
  'Mis acciones tienen impacto',
  'Puedo crear momentos',
  'Soy capaz de amar',
  'Tengo el poder de la resiliencia',
  'Puedo encontrar paz',
  'Soy digno de todo',
  'Mis palabras tienen poder',
  'Puedo hacer que cada dÃ­a cuente',
  'Soy una fuente de luz',
  'Tengo el poder de la autenticidad',
  'Puedo inspirar cambios',
  'Soy fuerte',
  'Mis pensamientos crean mi realidad',
  'Puedo hacer que la vida sea hermosa',
  'Soy capaz de amar profundamente',
  'Tengo el poder de la bondad',
  'Puedo encontrar fuerza',
  'Soy digno de respeto',
  'Mis acciones reflejan mi corazÃ³n',
  'Puedo hacer que otros se sientan especiales',
  'Soy una persona Ãºnica',
  'Tengo el poder de la esperanza',
  'Puedo superar',
  'Soy capaz de amar',
  'Mis sueÃ±os merecen ser perseguidos',
  'Puedo encontrar alegrÃ­a',
  'Soy digno de amor',
  'Tengo el poder de la determinaciÃ³n',
  'Puedo crear mi camino',
  'Soy fuerte',
  'Mis palabras pueden sanar',
  'Puedo hacer que otros se sientan bien',
  'Soy capaz de amar sin miedo',
  'Tengo el poder de la fe',
  'Puedo encontrar fuerza',
  'Soy digno de ser amado',
  'Mis acciones tienen propÃ³sito',
  'Puedo hacer que la vida sea especial',
  'Soy una persona de valor',
  'Tengo el poder de la pasiÃ³n',
  'Puedo encontrar significado',
  'Soy capaz de amar',
  'Mis elecciones crean mi futuro',
  'Puedo hacer que cada momento cuente',
  'Soy digno de amor incondicional',
  'Tengo el poder de la creatividad',
  'Puedo superar',
  'Soy fuerte',
  'Mis sueÃ±os merecen ser realidad',
  'Puedo hacer que el mundo sea mejor',
  'Soy capaz de amar',
  'Tengo el poder de la perseverancia',
  'Puedo encontrar felicidad',
  'Soy digno de respeto',
  'Mis acciones tienen significado',
  'Puedo crear mi destino',
  'Soy una persona maravillosa',
  'Tengo el poder de la esperanza',
  'Puedo hacer la diferencia',
  'Soy capaz de amar y ser amado',
  'Mis valores me guÃ­an',
  'Puedo encontrar fuerza',
  'Soy digno de Ã©xito',
  'Tengo el poder de la gratitud',
  'Puedo construir mi futuro',
  'Soy capaz',
  'Mis sueÃ±os merecen ser perseguidos',
  'Puedo encontrar belleza',
  'Soy digno de amor',
  'Tengo el poder de la compasiÃ³n',
  'Puedo hacer que otros sonrÃ­an',
  'Soy valioso',
  'Mis acciones tienen impacto'
];

export const DIARY_PROMPTS = [
  'Cuéntame sobre tu juguete favorito',
  '¿Qué fue lo más divertido de hoy?',
  '¿Con quién te gusta jugar?',
  '¿Qué te hace reír?',
  '¿Cuál es tu comida favorita?',
  '¿Qué animal te gusta más?'
];



